webpackJsonp([35783957827783],{

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

	!function(t,e){ true?module.exports=e(__webpack_require__(1),__webpack_require__(73)):"function"==typeof define&&define.amd?define("react-carousel",["react","react-dom"],e):"object"==typeof exports?exports["react-carousel"]=e(require("react"),require("react-dom")):t["react-carousel"]=e(t.React,t.ReactDOM)}(this,(function(t,e){return o={},n.m=r=[function(e,n){e.exports=t},function(t,e,n){var r=n(18);t.exports=n(31)(r.isElement,!0)},function(t,e,n){var r;
	/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/!function(){"use strict";var n={}.hasOwnProperty;function o(){for(var t=[],e=0;e<arguments.length;e++){var r=arguments[e];if(r){var i=typeof r;if("string"==i||"number"==i)t.push(r);else if(Array.isArray(r)&&r.length){var a=o.apply(null,r);a&&t.push(a)}else if("object"==i)for(var u in r)n.call(r,u)&&r[u]&&t.push(u)}}return t.join(" ")}t.exports?(o.default=o,t.exports=o):void 0===(r=function(){return o}.apply(e,[]))||(t.exports=r)}()},function(t,e){var n=Array.isArray;t.exports=n},function(t,e){t.exports=function(t){return null==t}},function(t,e){t.exports=function(t){var e=typeof t;return null!=t&&("object"==e||"function"==e)}},function(t,e,n){var r=n(37),o="object"==typeof self&&self&&self.Object===Object&&self,i=r||o||Function("return this")();t.exports=i},function(t,e,n){var r=n(14),o=n(15);t.exports=function(t){return"symbol"==typeof t||o(t)&&"[object Symbol]"==r(t)}},function(t,e,n){var r=n(6).Symbol;t.exports=r},function(t,e,n){var r=n(20)(Object,"create");t.exports=r},function(t,e,n){var r=n(64);t.exports=function(t,e){for(var n=t.length;n--;)if(r(t[n][0],e))return n;return-1}},function(t,e,n){var r=n(70);t.exports=function(t,e){var n=t.__data__;return r(e)?n["string"==typeof e?"string":"hash"]:n.map}},function(t,e,n){"use strict";t.exports="SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED"},function(t,e){var n=function(){return this}();try{n=n||new Function("return this")()}catch(t){"object"==typeof window&&(n=window)}t.exports=n},function(t,e,n){var r=n(8),o=n(38),i=n(39),a=r?r.toStringTag:void 0;t.exports=function(t){return null==t?void 0===t?"[object Undefined]":"[object Null]":(a&&a in Object(t)?o:i)(t)}},function(t,e){t.exports=function(t){return null!=t&&"object"==typeof t}},function(t,e,n){var r=n(22),o=n(81),i=n(83),a=n(3);t.exports=function(){var t=arguments.length;if(!t)return[];for(var e=Array(t-1),n=arguments[0],u=t;u--;)e[u-1]=arguments[u];return r(a(n)?i(n):[n],o(e,1))}},function(t,e,n){var r=n(84),o=n(85),i=n(87),a=4294967295,u=Math.min;t.exports=function(t,e){if((t=i(t))<1||9007199254740991<t)return[];var n=a,c=u(t,a);e=o(e),t-=a;for(var s=r(c,e);++n<t;)e(n);return s}},function(t,e,n){"use strict";t.exports=n(30)},function(t,e,n){var r=n(5),o=n(7),i=/^\s+|\s+$/g,a=/^[-+]0x[0-9a-f]+$/i,u=/^0b[01]+$/i,c=/^0o[0-7]+$/i,s=parseInt;t.exports=function(t){if("number"==typeof t)return t;if(o(t))return NaN;var e;if(r(t)&&(e="function"==typeof t.valueOf?t.valueOf():t,t=r(e)?e+"":e),"string"!=typeof t)return 0===t?t:+t;t=t.replace(i,"");var n=u.test(t);return n||c.test(t)?s(t.slice(2),n?2:8):a.test(t)?NaN:+t}},function(t,e,n){var r=n(51),o=n(56);t.exports=function(t,e){var n=o(t,e);return r(n)?n:void 0}},function(t,e,n){var r=n(77),o=n(15),i=Object.prototype,a=i.hasOwnProperty,u=i.propertyIsEnumerable,c=r(function(){return arguments}())?r:function(t){return o(t)&&a.call(t,"callee")&&!u.call(t,"callee")};t.exports=c},function(t,e){t.exports=function(t,e){for(var n=-1,r=e.length,o=t.length;++n<r;)t[o+n]=e[n];return t}},function(t,e,n){var r=n(35),o=n(5);t.exports=function(t,e,n){var i=!0,a=!0;if("function"!=typeof t)throw new TypeError("Expected a function");return o(n)&&(i="leading"in n?!!n.leading:i,a="trailing"in n?!!n.trailing:a),r(t,e,{leading:i,maxWait:e,trailing:a})}},function(t,e,n){var r=n(40),o=n(41);t.exports=function(t,e){return null!=t&&o(t,e,r)}},function(t,n){t.exports=e},function(t,e,n){"use strict";(function(t){var n=function(){if("undefined"!=typeof Map)return Map;function t(t,e){var n=-1;return t.some((function(t,r){return t[0]===e&&(n=r,!0)})),n}return Object.defineProperty(e.prototype,"size",{get:function(){return this.__entries__.length},enumerable:!0,configurable:!0}),e.prototype.get=function(e){var n=t(this.__entries__,e),r=this.__entries__[n];return r&&r[1]},e.prototype.set=function(e,n){var r=t(this.__entries__,e);~r?this.__entries__[r][1]=n:this.__entries__.push([e,n])},e.prototype.delete=function(e){var n=this.__entries__,r=t(n,e);~r&&n.splice(r,1)},e.prototype.has=function(e){return!!~t(this.__entries__,e)},e.prototype.clear=function(){this.__entries__.splice(0)},e.prototype.forEach=function(t,e){void 0===e&&(e=null);for(var n=0,r=this.__entries__;n<r.length;n++){var o=r[n];t.call(e,o[1],o[0])}},e;function e(){this.__entries__=[]}}(),r="undefined"!=typeof window&&"undefined"!=typeof document&&window.document===document,o=void 0!==t&&t.Math===Math?t:"undefined"!=typeof self&&self.Math===Math?self:"undefined"!=typeof window&&window.Math===Math?window:Function("return this")(),i="function"==typeof requestAnimationFrame?requestAnimationFrame.bind(o):function(t){return setTimeout((function(){return t(Date.now())}),1e3/60)},a=["top","right","bottom","left","width","height","size","weight"],u="undefined"!=typeof MutationObserver,c=(s.prototype.addObserver=function(t){~this.observers_.indexOf(t)||this.observers_.push(t),this.connected_||this.connect_()},s.prototype.removeObserver=function(t){var e=this.observers_,n=e.indexOf(t);~n&&e.splice(n,1),!e.length&&this.connected_&&this.disconnect_()},s.prototype.refresh=function(){this.updateObservers_()&&this.refresh()},s.prototype.updateObservers_=function(){var t=this.observers_.filter((function(t){return t.gatherActive(),t.hasActive()}));return t.forEach((function(t){return t.broadcastActive()})),0<t.length},s.prototype.connect_=function(){r&&!this.connected_&&(document.addEventListener("transitionend",this.onTransitionEnd_),window.addEventListener("resize",this.refresh),u?(this.mutationsObserver_=new MutationObserver(this.refresh),this.mutationsObserver_.observe(document,{attributes:!0,childList:!0,characterData:!0,subtree:!0})):(document.addEventListener("DOMSubtreeModified",this.refresh),this.mutationEventsAdded_=!0),this.connected_=!0)},s.prototype.disconnect_=function(){r&&this.connected_&&(document.removeEventListener("transitionend",this.onTransitionEnd_),window.removeEventListener("resize",this.refresh),this.mutationsObserver_&&this.mutationsObserver_.disconnect(),this.mutationEventsAdded_&&document.removeEventListener("DOMSubtreeModified",this.refresh),this.mutationsObserver_=null,this.mutationEventsAdded_=!1,this.connected_=!1)},s.prototype.onTransitionEnd_=function(t){var e=t.propertyName,n=void 0===e?"":e;a.some((function(t){return!!~n.indexOf(t)}))&&this.refresh()},s.getInstance=function(){return this.instance_||(this.instance_=new s),this.instance_},s.instance_=null,s);function s(){function t(){a&&(a=!1,r()),u&&n()}function e(){i(t)}function n(){var t=Date.now();if(a){if(t-c<2)return;u=!0}else u=!(a=!0),setTimeout(e,o);c=t}var r,o,a,u,c;this.connected_=!1,this.mutationEventsAdded_=!1,this.mutationsObserver_=null,this.observers_=[],this.onTransitionEnd_=this.onTransitionEnd_.bind(this),this.refresh=(r=this.refresh.bind(this),u=a=!(o=20),c=0,n)}var f=function(t,e){for(var n=0,r=Object.keys(e);n<r.length;n++){var o=r[n];Object.defineProperty(t,o,{value:e[o],enumerable:!1,writable:!1,configurable:!0})}return t},l=function(t){return t&&t.ownerDocument&&t.ownerDocument.defaultView||o},p=b(0,0,0,0);function d(t){return parseFloat(t)||0}function h(t){for(var e=[],n=1;n<arguments.length;n++)e[n-1]=arguments[n];return e.reduce((function(e,n){return e+d(t["border-"+n+"-width"])}),0)}var y="undefined"!=typeof SVGGraphicsElement?function(t){return t instanceof l(t).SVGGraphicsElement}:function(t){return t instanceof l(t).SVGElement&&"function"==typeof t.getBBox};function v(t){return r?y(t)?b(0,0,(e=t.getBBox()).width,e.height):function(t){var e=t.clientWidth,n=t.clientHeight;if(!e&&!n)return p;var r,o,i,a=l(t).getComputedStyle(t),u=function(t){for(var e={},n=0,r=["top","right","bottom","left"];n<r.length;n++){var o=r[n],i=t["padding-"+o];e[o]=d(i)}return e}(a),c=u.left+u.right,s=u.top+u.bottom,f=d(a.width),y=d(a.height);return"border-box"===a.boxSizing&&(Math.round(f+c)!==e&&(f-=h(a,"left","right")+c),Math.round(y+s)!==n&&(y-=h(a,"top","bottom")+s)),(i=t)!==l(i).document.documentElement&&(r=Math.round(f+c)-e,o=Math.round(y+s)-n,1!==Math.abs(r)&&(f-=r),1!==Math.abs(o)&&(y-=o)),b(u.left,u.top,f,y)}(t):p;var e}function b(t,e,n,r){return{x:t,y:e,width:n,height:r}}var g=(m.prototype.isActive=function(){var t=v(this.target);return(this.contentRect_=t).width!==this.broadcastWidth||t.height!==this.broadcastHeight},m.prototype.broadcastRect=function(){var t=this.contentRect_;return this.broadcastWidth=t.width,this.broadcastHeight=t.height,t},m);function m(t){this.broadcastWidth=0,this.broadcastHeight=0,this.contentRect_=b(0,0,0,0),this.target=t}var _=function(t,e){var n,r,o,i,a,u,c,s=(r=(n=e).x,o=n.y,i=n.width,a=n.height,u="undefined"!=typeof DOMRectReadOnly?DOMRectReadOnly:Object,c=Object.create(u.prototype),f(c,{x:r,y:o,width:i,height:a,top:o,right:r+i,bottom:a+o,left:r}),c);f(this,{target:t,contentRect:s})},w=(O.prototype.observe=function(t){if(!arguments.length)throw new TypeError("1 argument required, but only 0 present.");if("undefined"!=typeof Element&&Element instanceof Object){if(!(t instanceof l(t).Element))throw new TypeError('parameter 1 is not of type "Element".');var e=this.observations_;e.has(t)||(e.set(t,new g(t)),this.controller_.addObserver(this),this.controller_.refresh())}},O.prototype.unobserve=function(t){if(!arguments.length)throw new TypeError("1 argument required, but only 0 present.");if("undefined"!=typeof Element&&Element instanceof Object){if(!(t instanceof l(t).Element))throw new TypeError('parameter 1 is not of type "Element".');var e=this.observations_;e.has(t)&&(e.delete(t),e.size||this.controller_.removeObserver(this))}},O.prototype.disconnect=function(){this.clearActive(),this.observations_.clear(),this.controller_.removeObserver(this)},O.prototype.gatherActive=function(){var t=this;this.clearActive(),this.observations_.forEach((function(e){e.isActive()&&t.activeObservations_.push(e)}))},O.prototype.broadcastActive=function(){var t,e;this.hasActive()&&(t=this.callbackCtx_,e=this.activeObservations_.map((function(t){return new _(t.target,t.broadcastRect())})),this.callback_.call(t,e,t),this.clearActive())},O.prototype.clearActive=function(){this.activeObservations_.splice(0)},O.prototype.hasActive=function(){return 0<this.activeObservations_.length},O);function O(t,e,r){if(this.activeObservations_=[],this.observations_=new n,"function"!=typeof t)throw new TypeError("The callback provided as parameter 1 is not a function.");this.callback_=t,this.controller_=e,this.callbackCtx_=r}var S=new("undefined"!=typeof WeakMap?WeakMap:n),x=function t(e){if(!(this instanceof t))throw new TypeError("Cannot call a class as a function.");if(!arguments.length)throw new TypeError("1 argument required, but only 0 present.");var n=c.getInstance(),r=new w(e,n,this);S.set(this,r)};["observe","unobserve","disconnect"].forEach((function(t){x.prototype[t]=function(){var e;return(e=S.get(this))[t].apply(e,arguments)}}));var E=void 0!==o.ResizeObserver?o.ResizeObserver:x;e.a=E}).call(this,n(13))},function(t,e,n){"use strict";(function(t){var n="object"==typeof t&&t&&t.Object===Object&&t;e.a=n}).call(this,n(13))},,function(t,e,n){"use strict";
	/** @license React v16.13.1
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */var r="function"==typeof Symbol&&Symbol.for,o=r?Symbol.for("react.element"):60103,i=r?Symbol.for("react.portal"):60106,a=r?Symbol.for("react.fragment"):60107,u=r?Symbol.for("react.strict_mode"):60108,c=r?Symbol.for("react.profiler"):60114,s=r?Symbol.for("react.provider"):60109,f=r?Symbol.for("react.context"):60110,l=r?Symbol.for("react.async_mode"):60111,p=r?Symbol.for("react.concurrent_mode"):60111,d=r?Symbol.for("react.forward_ref"):60112,h=r?Symbol.for("react.suspense"):60113,y=r?Symbol.for("react.suspense_list"):60120,v=r?Symbol.for("react.memo"):60115,b=r?Symbol.for("react.lazy"):60116,g=r?Symbol.for("react.block"):60121,m=r?Symbol.for("react.fundamental"):60117,_=r?Symbol.for("react.responder"):60118,w=r?Symbol.for("react.scope"):60119;function O(t){if("object"==typeof t&&null!==t){var e=t.$$typeof;switch(e){case o:switch(t=t.type){case l:case p:case a:case c:case u:case h:return t;default:switch(t=t&&t.$$typeof){case f:case d:case b:case v:case s:return t;default:return e}}case i:return e}}}function S(t){return O(t)===p}e.AsyncMode=l,e.ConcurrentMode=p,e.ContextConsumer=f,e.ContextProvider=s,e.Element=o,e.ForwardRef=d,e.Fragment=a,e.Lazy=b,e.Memo=v,e.Portal=i,e.Profiler=c,e.StrictMode=u,e.Suspense=h,e.isAsyncMode=function(t){return S(t)||O(t)===l},e.isConcurrentMode=S,e.isContextConsumer=function(t){return O(t)===f},e.isContextProvider=function(t){return O(t)===s},e.isElement=function(t){return"object"==typeof t&&null!==t&&t.$$typeof===o},e.isForwardRef=function(t){return O(t)===d},e.isFragment=function(t){return O(t)===a},e.isLazy=function(t){return O(t)===b},e.isMemo=function(t){return O(t)===v},e.isPortal=function(t){return O(t)===i},e.isProfiler=function(t){return O(t)===c},e.isStrictMode=function(t){return O(t)===u},e.isSuspense=function(t){return O(t)===h},e.isValidElementType=function(t){return"string"==typeof t||"function"==typeof t||t===a||t===p||t===c||t===u||t===h||t===y||"object"==typeof t&&null!==t&&(t.$$typeof===b||t.$$typeof===v||t.$$typeof===s||t.$$typeof===f||t.$$typeof===d||t.$$typeof===m||t.$$typeof===_||t.$$typeof===w||t.$$typeof===g)},e.typeOf=O},function(t,e,n){"use strict";
	/** @license React v16.13.1
	 * react-is.development.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */function r(t){if("object"==typeof t&&null!==t){var e=t.$$typeof;switch(e){case a:var n=t.type;switch(n){case d:case h:case c:case f:case s:case v:return n;default:var r=n&&n.$$typeof;switch(r){case p:case y:case m:case g:case l:return r;default:return e}}case u:return e}}}function o(t){return r(t)===h}var i,a,u,c,s,f,l,p,d,h,y,v,b,g,m,_,w,O,S,x,E,j,P,C,T,R,k,A,M,$,I,D;i="function"==typeof Symbol&&Symbol.for,a=i?Symbol.for("react.element"):60103,u=i?Symbol.for("react.portal"):60106,c=i?Symbol.for("react.fragment"):60107,s=i?Symbol.for("react.strict_mode"):60108,f=i?Symbol.for("react.profiler"):60114,l=i?Symbol.for("react.provider"):60109,p=i?Symbol.for("react.context"):60110,d=i?Symbol.for("react.async_mode"):60111,h=i?Symbol.for("react.concurrent_mode"):60111,y=i?Symbol.for("react.forward_ref"):60112,v=i?Symbol.for("react.suspense"):60113,b=i?Symbol.for("react.suspense_list"):60120,g=i?Symbol.for("react.memo"):60115,m=i?Symbol.for("react.lazy"):60116,_=i?Symbol.for("react.block"):60121,w=i?Symbol.for("react.fundamental"):60117,O=i?Symbol.for("react.responder"):60118,S=i?Symbol.for("react.scope"):60119,x=h,E=p,j=l,P=a,C=y,T=c,R=m,k=g,A=u,M=f,$=s,I=v,D=!1,e.AsyncMode=d,e.ConcurrentMode=x,e.ContextConsumer=E,e.ContextProvider=j,e.Element=P,e.ForwardRef=C,e.Fragment=T,e.Lazy=R,e.Memo=k,e.Portal=A,e.Profiler=M,e.StrictMode=$,e.Suspense=I,e.isAsyncMode=function(t){return D||(D=!0,console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")),o(t)||r(t)===d},e.isConcurrentMode=o,e.isContextConsumer=function(t){return r(t)===p},e.isContextProvider=function(t){return r(t)===l},e.isElement=function(t){return"object"==typeof t&&null!==t&&t.$$typeof===a},e.isForwardRef=function(t){return r(t)===y},e.isFragment=function(t){return r(t)===c},e.isLazy=function(t){return r(t)===m},e.isMemo=function(t){return r(t)===g},e.isPortal=function(t){return r(t)===u},e.isProfiler=function(t){return r(t)===f},e.isStrictMode=function(t){return r(t)===s},e.isSuspense=function(t){return r(t)===v},e.isValidElementType=function(t){return"string"==typeof t||"function"==typeof t||t===c||t===h||t===f||t===s||t===v||t===b||"object"==typeof t&&null!==t&&(t.$$typeof===m||t.$$typeof===g||t.$$typeof===l||t.$$typeof===p||t.$$typeof===y||t.$$typeof===w||t.$$typeof===O||t.$$typeof===S||t.$$typeof===_)},e.typeOf=r},function(t,e,n){"use strict";var r,o=n(18),i=n(32),a=n(12),u=n(33),c=Function.call.bind(Object.prototype.hasOwnProperty);function s(){return null}r=function(t){var e="Warning: "+t;"undefined"!=typeof console&&console.error(e);try{throw new Error(e)}catch(t){}},t.exports=function(t,e){var n="function"==typeof Symbol&&Symbol.iterator,f="<<anonymous>>",l={array:y("array"),bool:y("boolean"),func:y("function"),number:y("number"),object:y("object"),string:y("string"),symbol:y("symbol"),any:h(s),arrayOf:function(t){return h((function(e,n,r,o,i){if("function"!=typeof t)return new d("Property `"+i+"` of component `"+r+"` has invalid PropType notation inside arrayOf.");var u=e[n];if(!Array.isArray(u))return new d("Invalid "+o+" `"+i+"` of type `"+b(u)+"` supplied to `"+r+"`, expected an array.");for(var c=0;c<u.length;c++){var s=t(u,c,r,o,i+"["+c+"]",a);if(s instanceof Error)return s}return null}))},element:h((function(e,n,r,o,i){var a=e[n];return t(a)?null:new d("Invalid "+o+" `"+i+"` of type `"+b(a)+"` supplied to `"+r+"`, expected a single ReactElement.")})),elementType:h((function(t,e,n,r,i){var a=t[e];return o.isValidElementType(a)?null:new d("Invalid "+r+" `"+i+"` of type `"+b(a)+"` supplied to `"+n+"`, expected a single ReactElement type.")})),instanceOf:function(t){return h((function(e,n,r,o,i){if(e[n]instanceof t)return null;var a,u=t.name||f;return new d("Invalid "+o+" `"+i+"` of type `"+((a=e[n]).constructor&&a.constructor.name?a.constructor.name:f)+"` supplied to `"+r+"`, expected instance of `"+u+"`.")}))},node:h((function(t,e,n,r,o){return v(t[e])?null:new d("Invalid "+r+" `"+o+"` supplied to `"+n+"`, expected a ReactNode.")})),objectOf:function(t){return h((function(e,n,r,o,i){if("function"!=typeof t)return new d("Property `"+i+"` of component `"+r+"` has invalid PropType notation inside objectOf.");var u=e[n],s=b(u);if("object"!==s)return new d("Invalid "+o+" `"+i+"` of type `"+s+"` supplied to `"+r+"`, expected an object.");for(var f in u)if(c(u,f)){var l=t(u,f,r,o,i+"."+f,a);if(l instanceof Error)return l}return null}))},oneOf:function(t){return Array.isArray(t)?h((function(e,n,r,o,i){for(var a=e[n],u=0;u<t.length;u++)if(p(a,t[u]))return null;var c=JSON.stringify(t,(function(t,e){return"symbol"===g(e)?String(e):e}));return new d("Invalid "+o+" `"+i+"` of value `"+String(a)+"` supplied to `"+r+"`, expected one of "+c+".")})):(r(1<arguments.length?"Invalid arguments supplied to oneOf, expected an array, got "+arguments.length+" arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).":"Invalid argument supplied to oneOf, expected an array."),s)},oneOfType:function(t){if(!Array.isArray(t))return r("Invalid argument supplied to oneOfType, expected an instance of array."),s;for(var e=0;e<t.length;e++){var n=t[e];if("function"!=typeof n)return r("Invalid argument supplied to oneOfType. Expected an array of check functions, but received "+m(n)+" at index "+e+"."),s}return h((function(e,n,r,o,i){for(var u=0;u<t.length;u++)if(null==(0,t[u])(e,n,r,o,i,a))return null;return new d("Invalid "+o+" `"+i+"` supplied to `"+r+"`.")}))},shape:function(t){return h((function(e,n,r,o,i){var u=e[n],c=b(u);if("object"!==c)return new d("Invalid "+o+" `"+i+"` of type `"+c+"` supplied to `"+r+"`, expected `object`.");for(var s in t){var f=t[s];if(f){var l=f(u,s,r,o,i+"."+s,a);if(l)return l}}return null}))},exact:function(t){return h((function(e,n,r,o,u){var c=e[n],s=b(c);if("object"!==s)return new d("Invalid "+o+" `"+u+"` of type `"+s+"` supplied to `"+r+"`, expected `object`.");var f=i({},e[n],t);for(var l in f){var p=t[l];if(!p)return new d("Invalid "+o+" `"+u+"` key `"+l+"` supplied to `"+r+"`.\nBad object: "+JSON.stringify(e[n],null,"  ")+"\nValid keys: "+JSON.stringify(Object.keys(t),null,"  "));var h=p(c,l,r,o,u+"."+l,a);if(h)return h}return null}))}};function p(t,e){return t===e?0!==t||1/t==1/e:t!=t&&e!=e}function d(t){this.message=t,this.stack=""}function h(t){var n={},o=0;function i(i,u,c,s,l,p,h){if(s=s||f,p=p||c,h!==a){if(e){var y=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");throw y.name="Invariant Violation",y}var v;"undefined"==typeof console||!n[v=s+":"+c]&&o<3&&(r("You are manually calling a React.PropTypes validation function for the `"+p+"` prop on `"+s+"`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."),n[v]=!0,o++)}return null==u[c]?i?null===u[c]?new d("The "+l+" `"+p+"` is marked as required in `"+s+"`, but its value is `null`."):new d("The "+l+" `"+p+"` is marked as required in `"+s+"`, but its value is `undefined`."):null:t(u,c,s,l,p)}var u=i.bind(null,!1);return u.isRequired=i.bind(null,!0),u}function y(t){return h((function(e,n,r,o,i,a){var u=e[n];return b(u)===t?null:new d("Invalid "+o+" `"+i+"` of type `"+g(u)+"` supplied to `"+r+"`, expected `"+t+"`.")}))}function v(e){switch(typeof e){case"number":case"string":case"undefined":return!0;case"boolean":return!e;case"object":if(Array.isArray(e))return e.every(v);if(null===e||t(e))return!0;var r=function(t){var e=t&&(n&&t[n]||t["@@iterator"]);if("function"==typeof e)return e}(e);if(!r)return!1;var o,i=r.call(e);if(r!==e.entries){for(;!(o=i.next()).done;)if(!v(o.value))return!1}else for(;!(o=i.next()).done;){var a=o.value;if(a&&!v(a[1]))return!1}return!0;default:return!1}}function b(t){var e,n=typeof t;return Array.isArray(t)?"array":t instanceof RegExp?"object":(e=t,"symbol"===n||e&&("Symbol"===e["@@toStringTag"]||"function"==typeof Symbol&&e instanceof Symbol)?"symbol":n)}function g(t){if(null==t)return""+t;var e=b(t);if("object"===e){if(t instanceof Date)return"date";if(t instanceof RegExp)return"regexp"}return e}function m(t){var e=g(t);switch(e){case"array":case"object":return"an "+e;case"boolean":case"date":case"regexp":return"a "+e;default:return e}}return d.prototype=Error.prototype,l.checkPropTypes=u,l.resetWarningCache=u.resetWarningCache,l.PropTypes=l}},function(t,e,n){"use strict";
	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/var r=Object.getOwnPropertySymbols,o=Object.prototype.hasOwnProperty,i=Object.prototype.propertyIsEnumerable;t.exports=function(){try{if(!Object.assign)return;var t=new String("abc");if(t[5]="de","5"===Object.getOwnPropertyNames(t)[0])return;for(var e={},n=0;n<10;n++)e["_"+String.fromCharCode(n)]=n;if("0123456789"!==Object.getOwnPropertyNames(e).map((function(t){return e[t]})).join(""))return;var r={};return"abcdefghijklmnopqrst".split("").forEach((function(t){r[t]=t})),"abcdefghijklmnopqrst"!==Object.keys(Object.assign({},r)).join("")?void 0:1}catch(t){return}}()?Object.assign:function(t,e){for(var n,a,u=function(t){if(null==t)throw new TypeError("Object.assign cannot be called with null or undefined");return Object(t)}(t),c=1;c<arguments.length;c++){for(var s in n=Object(arguments[c]))o.call(n,s)&&(u[s]=n[s]);if(r){a=r(n);for(var f=0;f<a.length;f++)i.call(n,a[f])&&(u[a[f]]=n[a[f]])}}return u}},function(t,e,n){"use strict";var r=n(12),o={},i=Function.call.bind(Object.prototype.hasOwnProperty),a=function(t){var e="Warning: "+t;"undefined"!=typeof console&&console.error(e);try{throw new Error(e)}catch(t){}};function u(t,e,n,u,c){for(var s in t)if(i(t,s)){var f,l;try{if("function"!=typeof t[s]){var p=Error((u||"React class")+": "+n+" type `"+s+"` is invalid; it must be a function, usually from the `prop-types` package, but received `"+typeof t[s]+"`.");throw p.name="Invariant Violation",p}f=t[s](e,s,u,n,null,r)}catch(t){f=t}!f||f instanceof Error||a((u||"React class")+": type specification of "+n+" `"+s+"` is invalid; the type checker function must return `null` or an `Error` but returned a "+typeof f+". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."),f instanceof Error&&!(f.message in o)&&(o[f.message]=!0,l=c?c():"",a("Failed "+n+" type: "+f.message+(null!=l?l:"")))}}u.resetWarningCache=function(){o={}},t.exports=u},function(t,e,n){"use strict";var r=n(12);function o(){}function i(){}i.resetWarningCache=o,t.exports=function(){function t(t,e,n,o,i,a){if(a!==r){var u=new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");throw u.name="Invariant Violation",u}}function e(){return t}var n={array:t.isRequired=t,bool:t,func:t,number:t,object:t,string:t,symbol:t,any:t,arrayOf:e,element:t,elementType:t,instanceOf:e,node:t,objectOf:e,oneOf:e,oneOfType:e,shape:e,exact:e,checkPropTypes:i,resetWarningCache:o};return n.PropTypes=n}},function(t,e,n){var r=n(5),o=n(36),i=n(19),a=Math.max,u=Math.min;t.exports=function(t,e,n){var c,s,f,l,p,d,h=0,y=!1,v=!1,b=!0;if("function"!=typeof t)throw new TypeError("Expected a function");function g(e){var n=c,r=s;return c=s=void 0,h=e,l=t.apply(r,n)}function m(t){var n=t-d;return void 0===d||e<=n||n<0||v&&f<=t-h}function _(){var t,n,r=o();if(m(r))return w(r);p=setTimeout(_,(n=e-((t=r)-d),v?u(n,f-(t-h)):n))}function w(t){return p=void 0,b&&c?g(t):(c=s=void 0,l)}function O(){var t,n=o(),r=m(n);if(c=arguments,s=this,d=n,r){if(void 0===p)return h=t=d,p=setTimeout(_,e),y?g(t):l;if(v)return clearTimeout(p),p=setTimeout(_,e),g(d)}return void 0===p&&(p=setTimeout(_,e)),l}return e=i(e)||0,r(n)&&(y=!!n.leading,f=(v="maxWait"in n)?a(i(n.maxWait)||0,e):f,b="trailing"in n?!!n.trailing:b),O.cancel=function(){void 0!==p&&clearTimeout(p),c=d=s=p=void(h=0)},O.flush=function(){return void 0===p?l:w(o())},O}},function(t,e,n){var r=n(6);t.exports=function(){return r.Date.now()}},function(t,e,n){(function(e){var n="object"==typeof e&&e&&e.Object===Object&&e;t.exports=n}).call(this,n(13))},function(t,e,n){var r=n(8),o=Object.prototype,i=o.hasOwnProperty,a=o.toString,u=r?r.toStringTag:void 0;t.exports=function(t){var e=i.call(t,u),n=t[u];try{var r=!(t[u]=void 0)}catch(t){}var o=a.call(t);return r&&(e?t[u]=n:delete t[u]),o}},function(t,e){var n=Object.prototype.toString;t.exports=function(t){return n.call(t)}},function(t,e){var n=Object.prototype.hasOwnProperty;t.exports=function(t,e){return null!=t&&n.call(t,e)}},function(t,e,n){var r=n(42),o=n(21),i=n(3),a=n(78),u=n(79),c=n(80);t.exports=function(t,e,n){for(var s=-1,f=(e=r(e,t)).length,l=!1;++s<f;){var p=c(e[s]);if(!(l=null!=t&&n(t,p)))break;t=t[p]}return l||++s!=f?l:!!(f=null==t?0:t.length)&&u(f)&&a(p,f)&&(i(t)||o(t))}},function(t,e,n){var r=n(3),o=n(43),i=n(44),a=n(74);t.exports=function(t,e){return r(t)?t:o(t,e)?[t]:i(a(t))}},function(t,e,n){var r=n(3),o=n(7),i=/\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,a=/^\w*$/;t.exports=function(t,e){if(r(t))return!1;var n=typeof t;return!("number"!=n&&"symbol"!=n&&"boolean"!=n&&null!=t&&!o(t))||a.test(t)||!i.test(t)||null!=e&&t in Object(e)}},function(t,e,n){var r=n(45),o=/[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g,i=/\\(\\)?/g,a=r((function(t){var e=[];return 46===t.charCodeAt(0)&&e.push(""),t.replace(o,(function(t,n,r,o){e.push(r?o.replace(i,"$1"):n||t)})),e}));t.exports=a},function(t,e,n){var r=n(46);t.exports=function(t){var e=r(t,(function(t){return 500===n.size&&n.clear(),t})),n=e.cache;return e}},function(t,e,n){var r=n(47);function o(t,e){if("function"!=typeof t||null!=e&&"function"!=typeof e)throw new TypeError("Expected a function");var n=function(){var r=arguments,o=e?e.apply(this,r):r[0],i=n.cache;if(i.has(o))return i.get(o);var a=t.apply(this,r);return n.cache=i.set(o,a)||i,a};return n.cache=new(o.Cache||r),n}o.Cache=r,t.exports=o},function(t,e,n){var r=n(48),o=n(69),i=n(71),a=n(72),u=n(73);function c(t){var e=-1,n=null==t?0:t.length;for(this.clear();++e<n;){var r=t[e];this.set(r[0],r[1])}}c.prototype.clear=r,c.prototype.delete=o,c.prototype.get=i,c.prototype.has=a,c.prototype.set=u,t.exports=c},function(t,e,n){var r=n(49),o=n(61),i=n(68);t.exports=function(){this.size=0,this.__data__={hash:new r,map:new(i||o),string:new r}}},function(t,e,n){var r=n(50),o=n(57),i=n(58),a=n(59),u=n(60);function c(t){var e=-1,n=null==t?0:t.length;for(this.clear();++e<n;){var r=t[e];this.set(r[0],r[1])}}c.prototype.clear=r,c.prototype.delete=o,c.prototype.get=i,c.prototype.has=a,c.prototype.set=u,t.exports=c},function(t,e,n){var r=n(9);t.exports=function(){this.__data__=r?r(null):{},this.size=0}},function(t,e,n){var r=n(52),o=n(53),i=n(5),a=n(55),u=/^\[object .+?Constructor\]$/,c=Function.prototype,s=Object.prototype,f=c.toString,l=s.hasOwnProperty,p=RegExp("^"+f.call(l).replace(/[\\^$.*+?()[\]{}|]/g,"\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g,"$1.*?")+"$");t.exports=function(t){return!(!i(t)||o(t))&&(r(t)?p:u).test(a(t))}},function(t,e,n){var r=n(14),o=n(5);t.exports=function(t){if(!o(t))return!1;var e=r(t);return"[object Function]"==e||"[object GeneratorFunction]"==e||"[object AsyncFunction]"==e||"[object Proxy]"==e}},function(t,e,n){var r,o=n(54),i=(r=/[^.]+$/.exec(o&&o.keys&&o.keys.IE_PROTO||""))?"Symbol(src)_1."+r:"";t.exports=function(t){return!!i&&i in t}},function(t,e,n){var r=n(6)["__core-js_shared__"];t.exports=r},function(t,e){var n=Function.prototype.toString;t.exports=function(t){if(null!=t){try{return n.call(t)}catch(t){}try{return t+""}catch(t){}}return""}},function(t,e){t.exports=function(t,e){return null==t?void 0:t[e]}},function(t,e){t.exports=function(t){var e=this.has(t)&&delete this.__data__[t];return this.size-=e?1:0,e}},function(t,e,n){var r=n(9),o=Object.prototype.hasOwnProperty;t.exports=function(t){var e=this.__data__;if(r){var n=e[t];return"__lodash_hash_undefined__"===n?void 0:n}return o.call(e,t)?e[t]:void 0}},function(t,e,n){var r=n(9),o=Object.prototype.hasOwnProperty;t.exports=function(t){var e=this.__data__;return r?void 0!==e[t]:o.call(e,t)}},function(t,e,n){var r=n(9);t.exports=function(t,e){var n=this.__data__;return this.size+=this.has(t)?0:1,n[t]=r&&void 0===e?"__lodash_hash_undefined__":e,this}},function(t,e,n){var r=n(62),o=n(63),i=n(65),a=n(66),u=n(67);function c(t){var e=-1,n=null==t?0:t.length;for(this.clear();++e<n;){var r=t[e];this.set(r[0],r[1])}}c.prototype.clear=r,c.prototype.delete=o,c.prototype.get=i,c.prototype.has=a,c.prototype.set=u,t.exports=c},function(t,e){t.exports=function(){this.__data__=[],this.size=0}},function(t,e,n){var r=n(10),o=Array.prototype.splice;t.exports=function(t){var e=this.__data__,n=r(e,t);return!(n<0||(n==e.length-1?e.pop():o.call(e,n,1),--this.size,0))}},function(t,e){t.exports=function(t,e){return t===e||t!=t&&e!=e}},function(t,e,n){var r=n(10);t.exports=function(t){var e=this.__data__,n=r(e,t);return n<0?void 0:e[n][1]}},function(t,e,n){var r=n(10);t.exports=function(t){return-1<r(this.__data__,t)}},function(t,e,n){var r=n(10);t.exports=function(t,e){var n=this.__data__,o=r(n,t);return o<0?(++this.size,n.push([t,e])):n[o][1]=e,this}},function(t,e,n){var r=n(20)(n(6),"Map");t.exports=r},function(t,e,n){var r=n(11);t.exports=function(t){var e=r(this,t).delete(t);return this.size-=e?1:0,e}},function(t,e){t.exports=function(t){var e=typeof t;return"string"==e||"number"==e||"symbol"==e||"boolean"==e?"__proto__"!==t:null===t}},function(t,e,n){var r=n(11);t.exports=function(t){return r(this,t).get(t)}},function(t,e,n){var r=n(11);t.exports=function(t){return r(this,t).has(t)}},function(t,e,n){var r=n(11);t.exports=function(t,e){var n=r(this,t),o=n.size;return n.set(t,e),this.size+=n.size==o?0:1,this}},function(t,e,n){var r=n(75);t.exports=function(t){return null==t?"":r(t)}},function(t,e,n){var r=n(8),o=n(76),i=n(3),a=n(7),u=r?r.prototype:void 0,c=u?u.toString:void 0;t.exports=function t(e){if("string"==typeof e)return e;if(i(e))return o(e,t)+"";if(a(e))return c?c.call(e):"";var n=e+"";return"0"==n&&1/e==-1/0?"-0":n}},function(t,e){t.exports=function(t,e){for(var n=-1,r=null==t?0:t.length,o=Array(r);++n<r;)o[n]=e(t[n],n,t);return o}},function(t,e,n){var r=n(14),o=n(15);t.exports=function(t){return o(t)&&"[object Arguments]"==r(t)}},function(t,e){var n=/^(?:0|[1-9]\d*)$/;t.exports=function(t,e){var r=typeof t;return!!(e=null==e?9007199254740991:e)&&("number"==r||"symbol"!=r&&n.test(t))&&-1<t&&t%1==0&&t<e}},function(t,e){t.exports=function(t){return"number"==typeof t&&-1<t&&t%1==0&&t<=9007199254740991}},function(t,e,n){var r=n(7);t.exports=function(t){if("string"==typeof t||r(t))return t;var e=t+"";return"0"==e&&1/t==-1/0?"-0":e}},function(t,e,n){var r=n(22),o=n(82);t.exports=function t(e,n,i,a,u){var c=-1,s=e.length;for(i=i||o,u=u||[];++c<s;){var f=e[c];0<n&&i(f)?1<n?t(f,n-1,i,a,u):r(u,f):a||(u[u.length]=f)}return u}},function(t,e,n){var r=n(8),o=n(21),i=n(3),a=r?r.isConcatSpreadable:void 0;t.exports=function(t){return i(t)||o(t)||!!(a&&t&&t[a])}},function(t,e){t.exports=function(t,e){var n=-1,r=t.length;for(e=e||Array(r);++n<r;)e[n]=t[n];return e}},function(t,e){t.exports=function(t,e){for(var n=-1,r=Array(t);++n<t;)r[n]=e(n);return r}},function(t,e,n){var r=n(86);t.exports=function(t){return"function"==typeof t?t:r}},function(t,e){t.exports=function(t){return t}},function(t,e,n){var r=n(88);t.exports=function(t){var e=r(t),n=e%1;return e==e?n?e-n:e:0}},function(t,e,n){var r=n(19);t.exports=function(t){return t?(t=r(t))!==1/0&&t!==-1/0?t==t?t:0:17976931348623157e292*(t<0?-1:1):0===t?t:0}},function(t,e,n){"use strict";n.r(e),n.d(e,"Dots",(function(){return zt}));var r=n(0),o=n.n(r),i=n(4),a=n.n(i),u=n(1),c=n(23),s=n.n(c),f=n(24),l=n.n(f),p=n(16),d=n.n(p),h=n(17),y=n.n(h),v=n(2),b=n.n(v),g=n(25),m=n(26),_=function(t){var e=typeof t;return null!=t&&("object"==e||"function"==e)},w=n(27),O="object"==typeof self&&self&&self.Object===Object&&self,S=w.a||O||Function("return this")(),x=function(){return S.Date.now()},E=S.Symbol,j=Object.prototype,P=j.hasOwnProperty,C=j.toString,T=E?E.toStringTag:void 0,R=function(t){var e=P.call(t,T),n=t[T];try{var r=!(t[T]=void 0)}catch(t){}var o=C.call(t);return r&&(e?t[T]=n:delete t[T]),o},k=Object.prototype.toString,A=function(t){return k.call(t)},M=E?E.toStringTag:void 0,$=function(t){return null==t?void 0===t?"[object Undefined]":"[object Null]":(M&&M in Object(t)?R:A)(t)},I=/^\s+|\s+$/g,D=/^[-+]0x[0-9a-f]+$/i,W=/^0b[01]+$/i,L=/^0o[0-7]+$/i,z=parseInt,N=function(t){if("number"==typeof t)return t;if(function(t){return"symbol"==typeof t||function(t){return null!=t&&"object"==typeof t}(t)&&"[object Symbol]"==$(t)}(t))return NaN;var e;if(_(t)&&(e="function"==typeof t.valueOf?t.valueOf():t,t=_(e)?e+"":e),"string"!=typeof t)return 0===t?t:+t;t=t.replace(I,"");var n=W.test(t);return n||L.test(t)?z(t.slice(2),n?2:8):D.test(t)?NaN:+t},F=Math.max,B=Math.min,V=function(t,e,n){var r,o,i,a,u,c,s=0,f=!1,l=!1,p=!0;if("function"!=typeof t)throw new TypeError("Expected a function");function d(e){var n=r,i=o;return r=o=void 0,s=e,a=t.apply(i,n)}function h(t){var n=t-c;return void 0===c||e<=n||n<0||l&&i<=t-s}function y(){var t,n,r=x();if(h(r))return v(r);u=setTimeout(y,(n=e-((t=r)-c),l?B(n,i-(t-s)):n))}function v(t){return u=void 0,p&&r?d(t):(r=o=void 0,a)}function b(){var t,n=x(),i=h(n);if(r=arguments,o=this,c=n,i){if(void 0===u)return s=t=c,u=setTimeout(y,e),f?d(t):a;if(l)return clearTimeout(u),u=setTimeout(y,e),d(c)}return void 0===u&&(u=setTimeout(y,e)),a}return e=N(e)||0,_(n)&&(f=!!n.leading,i=(l="maxWait"in n)?F(N(n.maxWait)||0,e):i,p="trailing"in n?!!n.trailing:p),b.cancel=function(){void 0!==u&&clearTimeout(u),r=c=o=u=void(s=0)},b.flush=function(){return void 0===u?a:v(x())},b};function H(t){return"function"==typeof t}function q(){return"undefined"==typeof window}var U={debounce:V,throttle:function(t,e,n){var r=!0,o=!0;if("function"!=typeof t)throw new TypeError("Expected a function");return _(n)&&(r="leading"in n?!!n.leading:r,o="trailing"in n?!!n.trailing:o),V(t,e,{leading:r,maxWait:e,trailing:o})}};function X(t){return(X="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Y(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}function G(t,e){return(G=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function J(t){return(J=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var K=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&G(t,e)}(o,r.PureComponent);var t,e,n=function(t){return function(){var e,n,r,o=J(t);return n=this,!(r=function(){if("undefined"!=typeof Reflect&&Reflect.construct&&!Reflect.construct.sham){if("function"==typeof Proxy)return 1;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),1}catch(t){return}}}()?(e=J(this).constructor,Reflect.construct(o,arguments,e)):o.apply(this,arguments))||"object"!==X(r)&&"function"!=typeof r?function(t){if(void 0!==t)return t;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(n):r}}(o);function o(){return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,o),n.apply(this,arguments)}return t=o,(e=[{key:"render",value:function(){return this.props.children}}])&&Y(t.prototype,e),o}();function Q(t){return(Q="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Z(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}function tt(t,e){return(tt=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function et(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function nt(t){return(nt=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function rt(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}var ot=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&tt(t,e)}(i,r.PureComponent);var t,e,n=function(t){return function(){var e,n,r,o=nt(t);return n=this,!(r=function(){if("undefined"!=typeof Reflect&&Reflect.construct&&!Reflect.construct.sham){if("function"==typeof Proxy)return 1;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),1}catch(t){return}}}()?(e=nt(this).constructor,Reflect.construct(o,arguments,e)):o.apply(this,arguments))||"object"!==Q(r)&&"function"!=typeof r?et(n):r}}(i);function i(t){var e;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i),rt(et(e=n.call(this,t)),"cancelHandler",(function(){e.resizeHandler&&e.resizeHandler.cancel&&(e.resizeHandler.cancel(),e.resizeHandler=null)})),rt(et(e),"rafClean",(function(){e.raf&&e.raf.cancel&&(e.raf.cancel(),e.raf=null)})),rt(et(e),"toggleObserver",(function(t){var n=e.getElement();n&&e.resizeObserver[t]&&e.resizeObserver[t](n)})),rt(et(e),"getElement",(function(){var t=e.props,n=t.querySelector,r=t.targetDomEl;if(!q()){if(n)return document.querySelector(n);if(r&&((o=r)instanceof Element||o instanceof HTMLDocument))return r;var o,i=e.element&&Object(g.findDOMNode)(e.element);if(i)return i.parentElement}})),rt(et(e),"createUpdater",(function(){return e.rafClean(),e.raf=function(t){function e(){for(var e=arguments.length,o=new Array(e),i=0;i<e;i++)o[i]=arguments[i];n=o,r=r||requestAnimationFrame((function(){r=null,t.apply(void 0,n)}))}var n=[],r=null;return e.cancel=function(){r&&(cancelAnimationFrame(r),r=null)},e}((function(t){var n=t.width,r=t.height,o=e.props.onResize;H(o)&&o(n,r),e.setState({width:n,height:r})})),e.raf})),rt(et(e),"createResizeHandler",(function(t){var n,r=e.state,o=r.width,i=r.height,a=e.props,u=a.handleWidth,c=a.handleHeight;(u||c)&&(n=e.createUpdater(),t.forEach((function(t){var r=t&&t.contentRect||{},a=r.width,s=r.height,f=u&&o!==a||c&&i!==s;e.skipOnMount||!f||q()||n({width:a,height:s}),e.skipOnMount=!1})))})),rt(et(e),"onRef",(function(t){e.element=t})),rt(et(e),"getRenderType",(function(){var t=e.props,n=t.render,o=t.children;return H(n)?"renderProp":H(o)?"childFunction":Object(r.isValidElement)(o)?"child":Array.isArray(o)?"childArray":"parent"})),rt(et(e),"getTargetComponent",(function(){var t=e.props,n=t.render,o=t.children,i=t.nodeType,a=e.state,u={width:a.width,height:a.height};switch(e.getRenderType()){case"renderProp":return Object(r.cloneElement)(n(u),{key:"resize-detector"});case"childFunction":return Object(r.cloneElement)(o(u));case"child":return Object(r.cloneElement)(o,u);case"childArray":return o.map((function(t){return!!t&&Object(r.cloneElement)(t,u)}));default:return Object(r.createElement)(i)}}));var o=t.skipOnMount,a=t.refreshMode,u=t.refreshRate,c=t.refreshOptions;e.state={width:void 0,height:void 0},e.skipOnMount=o,e.raf=null,e.element=null,e.unmounted=!1;var s=U[a];return e.resizeHandler=s?s(e.createResizeHandler,u,c):e.createResizeHandler,e.resizeObserver=new m.a(e.resizeHandler),e}return t=i,(e=[{key:"componentDidMount",value:function(){this.toggleObserver("observe")}},{key:"componentWillUnmount",value:function(){this.toggleObserver("unobserve"),this.rafClean(),this.cancelHandler(),this.unmounted=!0}},{key:"render",value:function(){return o.a.createElement(K,{ref:this.onRef},this.getTargetComponent())}}])&&Z(t.prototype,e),i}();ot.propTypes={handleWidth:u.bool,handleHeight:u.bool,skipOnMount:u.bool,refreshRate:u.number,refreshMode:u.string,refreshOptions:Object(u.shape)({leading:u.bool,trailing:u.bool}),querySelector:u.string,targetDomEl:u.any,onResize:u.func,render:u.func,children:u.any,nodeType:u.node},ot.defaultProps={handleWidth:!1,handleHeight:!1,skipOnMount:!1,refreshRate:1e3,refreshMode:void 0,refreshOptions:void 0,querySelector:null,targetDomEl:null,onResize:null,render:void 0,children:null,nodeType:"div"};var it=ot;function at(t){return(at="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function ut(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}function ct(t,e){return(ct=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function st(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function ft(t){return(ft=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function lt(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}n(90);var pt=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&ct(t,e)}(i,r.PureComponent);var t,e,n=function(t){var e=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(t){return!1}}();return function(){var n,r,o,i=ft(t);return r=this,!(o=e?(n=ft(this).constructor,Reflect.construct(i,arguments,n)):i.apply(this,arguments))||"object"!==at(o)&&"function"!=typeof o?st(r):o}}(i);function i(){var t;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i);for(var e=arguments.length,r=new Array(e),o=0;o<e;o++)r[o]=arguments[o];return lt(st(t=n.call.apply(n,[this].concat(r))),"onMouseDown",(function(e){t.props.onMouseDown(e,t.props.index)})),lt(st(t),"onTouchStart",(function(e){t.props.onTouchStart(e,t.props.index)})),t}return t=i,(e=[{key:"render",value:function(){return o.a.createElement("li",{className:b()("BrainhubCarouselItem",{"BrainhubCarouselItem--clickable":this.props.clickable,"BrainhubCarouselItem--active":this.props.index===this.props.currentSlideIndex}),style:{paddingRight:"".concat(this.props.offset/2,"px"),paddingLeft:"".concat(this.props.offset/2,"px"),width:"".concat(this.props.width,"px"),maxWidth:"".concat(this.props.width,"px"),minWidth:"".concat(this.props.width,"px"),pointerEvents:this.props.isDragging?"none":null},onMouseDown:this.props.isDraggingEnabled?this.onMouseDown:null,onTouchStart:this.props.isDraggingEnabled?this.onTouchStart:null},this.props.children)}}])&&ut(t.prototype,e),i}();function dt(t){return(dt="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function ht(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}function yt(t,e){return(yt=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function vt(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function bt(t){return(bt=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function gt(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}n(94);var mt=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&yt(t,e)}(i,r.Component);var t,e,n=function(t){var e=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(t){return!1}}();return function(){var n,r,o,i=bt(t);return r=this,!(o=e?(n=bt(this).constructor,Reflect.construct(i,arguments,n)):i.apply(this,arguments))||"object"!==dt(o)&&"function"!=typeof o?vt(r):o}}(i);function i(){var t;!function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i);for(var e=arguments.length,r=new Array(e),o=0;o<e;o++)r[o]=arguments[o];return gt(vt(t=n.call.apply(n,[this].concat(r))),"onChange",(function(e){return function(){var n=t.props.number||t.props.thumbnails.length,r=t.calculateButtonValue()%n;return t.props.onChange(t.props.value-(r-e))}})),gt(vt(t),"calculateButtonValue",(function(){var e=t.props.number||t.props.thumbnails.length;return 0<=t.props.value?t.props.value:t.props.value+e*Math.ceil(Math.abs(t.props.value/e))})),t}return t=i,(e=[{key:"renderCarouselDots",value:function(){var t=this;if(this.props.thumbnails){var e=isNaN(this.props.number)?this.props.thumbnails.length:this.props.number;return this.props.thumbnails.slice(0,e).map((function(n,r){return o.a.createElement("li",{key:r},o.a.createElement("button",{className:b()("BrainhubCarousel__thumbnail",{"BrainhubCarousel__thumbnail--selected":r===t.calculateButtonValue()%e}),type:"button",onClick:t.onChange(r)},n))}))}for(var n=[],r=0;r<this.props.number;r++)n.push(o.a.createElement("li",{key:r},o.a.createElement("button",{className:b()("BrainhubCarousel__dot",{"BrainhubCarousel__dot--selected":r===this.calculateButtonValue()%this.props.number}),type:"button",onClick:this.onChange(r)},r+1)));return n}},{key:"render",value:function(){var t=this.props,e=t.className,n=t.rtl;return o.a.createElement("ul",{className:b()("BrainhubCarousel__dots",e,n?"BrainhubCarousel__dots--isRTL":"")},this.renderCarouselDots())}}])&&ht(t.prototype,e),i}();function _t(t){return(_t="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function wt(t){return function(t){if(Array.isArray(t))return Ot(t)}(t)||function(t){if("undefined"!=typeof Symbol&&Symbol.iterator in Object(t))return Array.from(t)}(t)||function(t,e){if(t){if("string"==typeof t)return Ot(t,e);var n=Object.prototype.toString.call(t).slice(8,-1);return"Object"===n&&t.constructor&&(n=t.constructor.name),"Map"===n||"Set"===n?Array.from(t):"Arguments"===n||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)?Ot(t,e):void 0}}(t)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function Ot(t,e){(null==e||e>t.length)&&(e=t.length);for(var n=0,r=new Array(e);n<e;n++)r[n]=t[n];return r}function St(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}function xt(t,e){return(xt=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function Et(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function jt(t){return(jt=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}function Pt(t,e,n){return e in t?Object.defineProperty(t,e,{value:n,enumerable:!0,configurable:!0,writable:!0}):t[e]=n,t}n(96),n(98);var Ct=o.a.createElement("span",null,"prev"),Tt=o.a.createElement("span",null,"next"),Rt=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&xt(t,e)}(i,r.Component);var t,e,n=function(t){var e=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(t){return!1}}();return function(){var n,r,o,i=jt(t);return r=this,!(o=e?(n=jt(this).constructor,Reflect.construct(i,arguments,n)):i.apply(this,arguments))||"object"!==_t(o)&&"function"!=typeof o?Et(r):o}}(i);function i(t){var e;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i),Pt(Et(e=n.call(this,t)),"getCurrentValue",(function(){return e.props.infinite?e.props.value:e.clamp(e.props.value)})),Pt(Et(e),"getNeededAdditionalClones",(function(){return Math.ceil((e.getCurrentValue()-e.state.infiniteTransitionFrom)/e.getChildren().length)})),Pt(Et(e),"getAdditionalClonesLeft",(function(){var t=e.getNeededAdditionalClones();return t<0?-t:0})),Pt(Et(e),"getAdditionalClonesRight",(function(){var t=e.getNeededAdditionalClones();return 0<t?t:0})),Pt(Et(e),"getClonesLeft",(function(){return 3+e.getAdditionalClonesLeft()})),Pt(Et(e),"getClonesRight",(function(){return 3+e.getAdditionalClonesRight()})),Pt(Et(e),"getAdditionalClonesOffset",(function(){return-e.getChildren().length*e.getCarouselElementWidth()*e.getAdditionalClonesLeft()})),Pt(Et(e),"getProp",(function(t){var n,r=(1<arguments.length&&void 0!==arguments[1]?arguments[1]:null)||e.props,o=null;return r.breakpoints&&(n=e.state.windowWidth,Object.keys(r.breakpoints).forEach((function(t){var e=parseInt(t);n<=e&&(!o||e<o)&&(o=e)}))),o&&l()(r.breakpoints[o],t)?r.breakpoints[o][t]:r[t]})),Pt(Et(e),"checkIfValueChanged",(function(t){return(e.getProp("infinite")?e.props.value:e.clamp(e.props.value))!==(e.getProp("infinite")?t.value:e.clamp(t.value))})),Pt(Et(e),"resetInterval",(function(){e.interval&&clearInterval(e.interval);var t=e.getProp("autoPlay");a()(t)||(e.interval=setInterval((function(){document.hidden||e.state.isAutoPlayStopped||e.nextSlide()}),t))})),Pt(Et(e),"getChildren",(function(){return e.props.children?Array.isArray(e.props.children)?e.props.children:[e.props.children]:e.props.slides?e.props.slides:[]})),Pt(Et(e),"getActiveSlideIndex",(function(){return e.getProp("infinite")?e.getCurrentSlideIndex()+e.getClonesLeft()*e.getChildren().length:e.getCurrentSlideIndex()})),Pt(Et(e),"getTargetMod",(function(){var t=0<arguments.length&&void 0!==arguments[0]?arguments[0]:null,n=a()(t)?e.getCurrentValue():t,r=e.getChildren().length,o=0<=n?n%r:(r-Math.abs(n%r))%r;return o})),Pt(Et(e),"getTargetSlide",(function(){return a()(e.state.infiniteTransitionFrom)?e.getTargetMod():e.getTargetMod(e.state.infiniteTransitionFrom)+(e.getCurrentValue()-e.state.infiniteTransitionFrom)})),Pt(Et(e),"onResize",s()((function(){var t,n,r;e.node&&(t=e.arrowLeftNode&&e.arrowLeftNode.offsetWidth,n=e.arrowRightNode&&e.arrowRightNode.offsetWidth,r=e.node.offsetWidth-(t||0)-(n||0),e.setState((function(){return{carouselWidth:r,windowWidth:window.innerWidth}})))}),300)),Pt(Et(e),"onMouseDown",(function(t,n){t.preventDefault(),t.stopPropagation();var r=t.pageX;e.setState((function(){return{clicked:n,dragStart:r}}))})),Pt(Et(e),"onMouseMove",(function(t){var n=t.pageX;null!==e.state.dragStart&&e.setState((function(t){return{dragOffset:e.getProp("rtl")?t.dragStart-n:n-t.dragStart}}))})),Pt(Et(e),"onTouchStart",(function(t,n){var r=t.changedTouches;e.setState((function(){return{clicked:n,dragStart:r[0].pageX}}))})),Pt(Et(e),"onMouseUpTouchEnd",(function(t){null!==e.state.dragStart&&(t.preventDefault(),e.getProp("draggable")&&Math.abs(e.state.dragOffset)>10?e.changeSlide(e.getNearestSlideIndex()):e.getProp("clickToChange")&&e.changeSlide(e.getProp("infinite")?e.getCurrentValue()+e.state.clicked-e.getActiveSlideIndex():e.state.clicked),e.setState((function(){return{clicked:null,dragOffset:0,dragStart:null,transitionEnabled:!0}})))})),Pt(Et(e),"onTransitionEnd",(function(){var t=e.getProp("infinite");e.setState((function(){return{transitionEnabled:!t,infiniteTransitionFrom:t?e.getCurrentValue():null}}))})),Pt(Et(e),"onMouseEnter",(function(){e.setState((function(){return{isAutoPlayStopped:!0}}))})),Pt(Et(e),"onMouseLeave",(function(){e.setState((function(){return{isAutoPlayStopped:!1}})),e.resetInterval()})),Pt(Et(e),"simulateEvent",(function(t){var e=t.changedTouches[0],n=e.screenX,r=e.screenY,o=e.clientX,i=e.clientY,a=new MouseEvent({touchstart:"mousedown",touchmove:"mousemove",touchend:"mouseup"}[t.type],{bubbles:!0,cancelable:!0,view:window,detail:1,screenX:n,screenY:r,clientX:o,clientY:i});e.target.dispatchEvent(a)})),Pt(Et(e),"clamp",(function(t){var n=e.getChildren().length-1;return n<t?n:t<0?0:t})),Pt(Et(e),"changeSlide",(function(t){return e.props.onChange(e.getProp("infinite")?t:e.clamp(t))})),Pt(Et(e),"nextSlide",(function(){return e.changeSlide(e.getCurrentValue()+e.getProp("slidesPerScroll"))})),Pt(Et(e),"prevSlide",(function(){return e.changeSlide(e.getCurrentValue()-e.getProp("slidesPerScroll"))})),Pt(Et(e),"getNearestSlideIndex",(function(){var t=e.getProp("keepDirectionWhenDragging")?0<e.state.dragOffset?-Math.ceil(e.state.dragOffset/e.getCarouselElementWidth()):-Math.floor(e.state.dragOffset/e.getCarouselElementWidth()):-Math.round(e.state.dragOffset/e.getCarouselElementWidth());return e.getCurrentValue()+t})),Pt(Et(e),"getCurrentSlideIndex",(function(){return e.getProp("infinite")?e.getTargetSlide():e.clamp(e.getCurrentValue())})),Pt(Et(e),"getCarouselElementWidth",(function(){return e.getProp("itemWidth")||e.state.carouselWidth/e.getProp("slidesPerPage")})),Pt(Et(e),"getTransformOffset",(function(){var t=e.getCarouselElementWidth()+e.getProp("offset"),n=e.getProp("centered")?e.state.carouselWidth/2-t/2:0;return(e.getProp("draggable")?e.state.dragOffset:0)-e.getActiveSlideIndex()*t+n-e.getAdditionalClonesOffset()})),Pt(Et(e),"renderCarouselItems",(function(){var t=e.getProp("rtl"),n=e.getTransformOffset(),r=e.getChildren(),i=e.getClonesLeft(),a=e.getClonesRight(),u=1+(e.getProp("infinite")?i+a:0),c=e.state.carouselWidth*r.length*u,s=e.getProp("animationSpeed"),f=e.state.transitionEnabled,l=e.getProp("draggable")&&r&&1<r.length,p={width:"".concat(c,"px"),transitionDuration:f?"".concat(s,"ms, ").concat(s,"ms"):null};t?(p.marginRight="".concat(e.getAdditionalClonesOffset(),"px"),p.transform="translateX(".concat(-n,"px)")):(p.marginLeft="".concat(e.getAdditionalClonesOffset(),"px"),p.transform="translateX(".concat(n,"px)"));var h,v,g=r;function m(t){return _&&w?t:null}e.getProp("infinite")&&(h=y()(i,(function(){return r})),v=y()(a,(function(){return r})),g=t?d.a.apply(void 0,wt(v).concat([r],wt(h))):d.a.apply(void 0,wt(h).concat([r],wt(v))));var _=e.getProp("autoPlay"),w=e.getProp("stopAutoPlayOnHover");return o.a.createElement("div",{className:"BrainhubCarousel__trackContainer"},o.a.createElement("ul",{className:b()("BrainhubCarousel__track",{"BrainhubCarousel__track--transition":f,"BrainhubCarousel__track--draggable":l}),style:p,ref:function(t){return e.trackRef=t},onMouseEnter:m(e.onMouseEnter),onMouseLeave:m(e.onMouseLeave)},g.map((function(t,n){return[null,void 0].includes(t)?null:o.a.createElement(pt,{key:n,currentSlideIndex:e.getActiveSlideIndex(),index:n,width:e.getCarouselElementWidth(),offset:n!==g.length?e.props.offset:0,onMouseDown:e.onMouseDown,onTouchStart:e.onTouchStart,clickable:e.getProp("clickToChange"),isDragging:Math.abs(e.state.dragOffset)>e.props.minDraggableOffset,isDraggingEnabled:e.props.draggable||e.props.clickToChange},t)}))))})),Pt(Et(e),"renderArrowWithAddedHandler",(function(t,n,r){var i=3<arguments.length&&void 0!==arguments[3]&&arguments[3];return o.a.createElement("div",{className:b()("BrainhubCarousel__customArrows",{"BrainhubCarousel__arrow--disable":i},"BrainhubCarousel__custom-".concat(r)),ref:function(t){return e["".concat(r,"Node")]=t},onClick:e.getProp("addArrowClickHandler")?n:null},t)})),Pt(Et(e),"renderArrowLeft",(function(){var t=e.getCurrentValue()<=0&&!e.getProp("infinite");if(e.getProp("arrowLeft")){if(!t)return e.renderArrowWithAddedHandler(e.getProp("arrowLeft"),e.prevSlide,"arrowLeft");var n=e.getProp("arrowLeftDisabled")?e.getProp("arrowLeftDisabled"):e.getProp("arrowLeft");return e.renderArrowWithAddedHandler(n,e.prevSlide,"arrowLeft",t)}return e.getProp("arrows")?o.a.createElement("button",{className:"BrainhubCarousel__arrows BrainhubCarousel__arrowLeft",onClick:e.prevSlide,ref:function(t){return e.arrowLeftNode=t},disabled:t},Ct):null})),Pt(Et(e),"renderArrowRight",(function(){var t=e.getChildren(),n=e.getCurrentValue()===t.length-1&&!e.getProp("infinite");if(e.getProp("arrowRight")){if(!n)return e.renderArrowWithAddedHandler(e.getProp("arrowRight"),e.nextSlide,"arrowRight");var r=e.getProp("arrowRightDisabled")?e.getProp("arrowRightDisabled"):e.getProp("arrowRight");return e.renderArrowWithAddedHandler(r,e.nextSlide,"arrowRight",n)}return e.getProp("arrows")?o.a.createElement("button",{className:"BrainhubCarousel__arrows BrainhubCarousel__arrowRight",onClick:e.nextSlide,ref:function(t){return e.arrowRightNode=t},disabled:n},Tt):null})),e.state={carouselWidth:0,windowWidth:0,clicked:null,dragOffset:0,dragStart:null,transitionEnabled:!1,infiniteTransitionFrom:t.infinite?t.value:null,isAutoPlayStopped:!1},e.interval=null,e}return t=i,(e=[{key:"componentDidMount",value:function(){this.trackRef&&this.trackRef.addEventListener("transitionend",this.onTransitionEnd),this.node&&(this.node.parentElement.addEventListener("mousemove",this.onMouseMove,!0),document.addEventListener("mouseup",this.onMouseUpTouchEnd,!0),this.node.parentElement.addEventListener("touchstart",this.simulateEvent,!0),this.node.parentElement.addEventListener("touchmove",this.simulateEvent,{passive:!1}),this.node.parentElement.addEventListener("touchend",this.simulateEvent,!0)),this.onResize(),this.resetInterval()}},{key:"componentDidUpdate",value:function(t){var e=this.checkIfValueChanged(t);this.getProp("autoPlay")===this.getProp("autoPlay",t)&&!e||this.resetInterval(),e&&this.setState({transitionEnabled:!0})}},{key:"componentWillUnmount",value:function(){this.trackRef&&this.trackRef.removeEventListener("transitionend",this.onTransitionEnd),this.node&&(this.node.parentElement.removeEventListener("mousemove",this.onMouseMove),document.removeEventListener("mouseup",this.onMouseUpTouchEnd),this.node.parentElement.removeEventListener("touchstart",this.simulateEvent),this.node.parentElement.removeEventListener("touchmove",this.simulateEvent),this.node.parentElement.removeEventListener("touchend",this.simulateEvent)),this.interval&&clearInterval(this.interval)}},{key:"renderDots",value:function(){return this.getProp("dots")?o.a.createElement(mt,{value:this.getCurrentValue(),onChange:this.changeSlide,number:this.getChildren().length,rtl:this.getProp("rtl")}):null}},{key:"render",value:function(){var t=this,e=this.getProp("rtl");return o.a.createElement("div",{className:"BrainhubCarousel__container"},o.a.createElement("div",{className:b()("BrainhubCarousel",this.getProp("className"),e?"BrainhubCarousel--isRTL":""),ref:function(e){return t.node=e}},o.a.createElement(it,{handleWidth:!0,onResize:this.onResize},o.a.createElement(this.renderArrowLeft,{key:"arrow-left"}),o.a.createElement(this.renderCarouselItems,{key:"carousel"}),o.a.createElement(this.renderArrowRight,{key:"arrow-right"}))),this.renderDots())}}])&&St(t.prototype,e),i}();Pt(Rt,"defaultProps",{offset:0,slidesPerPage:1,slidesPerScroll:1,animationSpeed:500,draggable:!0,rtl:!1,minDraggableOffset:10});var kt=Rt;function At(t){return(At="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t})(t)}function Mt(){return(Mt=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var r in n)Object.prototype.hasOwnProperty.call(n,r)&&(t[r]=n[r])}return t}).apply(this,arguments)}function $t(t,e){for(var n=0;n<e.length;n++){var r=e[n];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(t,r.key,r)}}function It(t,e){return(It=Object.setPrototypeOf||function(t,e){return t.__proto__=e,t})(t,e)}function Dt(t){if(void 0===t)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return t}function Wt(t){return(Wt=Object.setPrototypeOf?Object.getPrototypeOf:function(t){return t.__proto__||Object.getPrototypeOf(t)})(t)}var Lt=function(){!function(t,e){if("function"!=typeof e&&null!==e)throw new TypeError("Super expression must either be null or a function");t.prototype=Object.create(e&&e.prototype,{constructor:{value:t,writable:!0,configurable:!0}}),e&&It(t,e)}(i,r.Component);var t,e,n=function(t){var e=function(){if("undefined"==typeof Reflect||!Reflect.construct)return!1;if(Reflect.construct.sham)return!1;if("function"==typeof Proxy)return!0;try{return Date.prototype.toString.call(Reflect.construct(Date,[],(function(){}))),!0}catch(t){return!1}}();return function(){var n,r,o,i=Wt(t);return r=this,!(o=e?(n=Wt(this).constructor,Reflect.construct(i,arguments,n)):i.apply(this,arguments))||"object"!==At(o)&&"function"!=typeof o?Dt(r):o}}(i);function i(t){var e,r,o,a;return function(t,e){if(!(t instanceof e))throw new TypeError("Cannot call a class as a function")}(this,i),a=function(t){return e.setState({value:t})},(o="onChange")in(r=Dt(e=n.call(this,t)))?Object.defineProperty(r,o,{value:a,enumerable:!0,configurable:!0,writable:!0}):r[o]=a,e.state={value:0},e}return t=i,(e=[{key:"render",value:function(){var t=this.props,e=t.value,n=t.onChange,r=function(t,e){if(null==t)return{};var n,r=function(t,e){if(null==t)return{};var n,r,o={},i=Object.keys(t);for(r=0;r<i.length;r++)n=i[r],0<=e.indexOf(n)||(o[n]=t[n]);return o}(t,e);if(Object.getOwnPropertySymbols)for(var o=Object.getOwnPropertySymbols(t),i=0;i<o.length;i++)n=o[i],0<=e.indexOf(n)||Object.prototype.propertyIsEnumerable.call(t,n)&&(r[n]=t[n]);return r}(t,["value","onChange"]),i=!a()(e);return o.a.createElement(kt,Mt({value:i?parseInt(e):this.state.value,onChange:i?n:this.onChange},r))}}])&&$t(t.prototype,e),i}(),zt=mt;e.default=Lt},function(t,e){},,,,function(t,e){},,function(t,e){},,function(t,e){}],n.c=o,n.d=function(t,e,r){n.o(t,e)||Object.defineProperty(t,e,{enumerable:!0,get:r})},n.r=function(t){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(t,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(t,"__esModule",{value:!0})},n.t=function(t,e){if(1&e&&(t=n(t)),8&e)return t;if(4&e&&"object"==typeof t&&t&&t.__esModule)return t;var r=Object.create(null);if(n.r(r),Object.defineProperty(r,"default",{enumerable:!0,value:t}),2&e&&"string"!=typeof t)for(var o in t)n.d(r,o,function(e){return t[e]}.bind(null,o));return r},n.n=function(t){var e=t&&t.__esModule?function(){return t.default}:function(){return t};return n.d(e,"a",e),e},n.o=function(t,e){return Object.prototype.hasOwnProperty.call(t,e)},n.p="",n(n.s=89);function n(t){if(o[t])return o[t].exports;var e=o[t]={i:t,l:!1,exports:{}};return r[t].call(e.exports,e,e.exports,n),e.l=!0,e.exports}var r,o}));

/***/ }),

/***/ 228:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 29:
/***/ (function(module, exports, __webpack_require__) {

	/*!
	 * Font Awesome Free 5.0.13 by @fontawesome - https://fontawesome.com
	 * License - https://fontawesome.com/license (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
	 */
	(function (global, factory) {
		 true ? factory(exports) :
		typeof define === 'function' && define.amd ? define(['exports'], factory) :
		(factory((global.fontawesome = {})));
	}(this, (function (exports) { 'use strict';
	
	var noop = function noop() {};
	
	var _WINDOW = {};
	var _DOCUMENT = {};
	var _MUTATION_OBSERVER$1 = null;
	var _PERFORMANCE = { mark: noop, measure: noop };
	
	try {
	  if (typeof window !== 'undefined') _WINDOW = window;
	  if (typeof document !== 'undefined') _DOCUMENT = document;
	  if (typeof MutationObserver !== 'undefined') _MUTATION_OBSERVER$1 = MutationObserver;
	  if (typeof performance !== 'undefined') _PERFORMANCE = performance;
	} catch (e) {}
	
	var _ref = _WINDOW.navigator || {};
	var _ref$userAgent = _ref.userAgent;
	var userAgent = _ref$userAgent === undefined ? '' : _ref$userAgent;
	
	var WINDOW = _WINDOW;
	var DOCUMENT = _DOCUMENT;
	var MUTATION_OBSERVER = _MUTATION_OBSERVER$1;
	var PERFORMANCE = _PERFORMANCE;
	var IS_BROWSER = !!WINDOW.document;
	var IS_DOM = !!DOCUMENT.documentElement && !!DOCUMENT.head && typeof DOCUMENT.addEventListener === 'function' && typeof DOCUMENT.createElement === 'function';
	var IS_IE = ~userAgent.indexOf('MSIE') || ~userAgent.indexOf('Trident/');
	
	var NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
	var UNITS_IN_GRID = 16;
	var DEFAULT_FAMILY_PREFIX = 'fa';
	var DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
	var DATA_FA_I2SVG = 'data-fa-i2svg';
	var DATA_FA_PSEUDO_ELEMENT = 'data-fa-pseudo-element';
	var HTML_CLASS_I2SVG_BASE_CLASS = 'fontawesome-i2svg';
	
	var PRODUCTION = function () {
	  try {
	    return ("production") === 'production';
	  } catch (e) {
	    return false;
	  }
	}();
	
	var oneToTen = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
	var oneToTwenty = oneToTen.concat([11, 12, 13, 14, 15, 16, 17, 18, 19, 20]);
	
	var ATTRIBUTES_WATCHED_FOR_MUTATION = ['class', 'data-prefix', 'data-icon', 'data-fa-transform', 'data-fa-mask'];
	
	var RESERVED_CLASSES = ['xs', 'sm', 'lg', 'fw', 'ul', 'li', 'border', 'pull-left', 'pull-right', 'spin', 'pulse', 'rotate-90', 'rotate-180', 'rotate-270', 'flip-horizontal', 'flip-vertical', 'stack', 'stack-1x', 'stack-2x', 'inverse', 'layers', 'layers-text', 'layers-counter'].concat(oneToTen.map(function (n) {
	  return n + 'x';
	})).concat(oneToTwenty.map(function (n) {
	  return 'w-' + n;
	}));
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	
	
	var toConsumableArray = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	    return arr2;
	  } else {
	    return Array.from(arr);
	  }
	};
	
	var initial = WINDOW.FontAwesomeConfig || {};
	var initialKeys = Object.keys(initial);
	
	var _default = _extends({
	  familyPrefix: DEFAULT_FAMILY_PREFIX,
	  replacementClass: DEFAULT_REPLACEMENT_CLASS,
	  autoReplaceSvg: true,
	  autoAddCss: true,
	  autoA11y: true,
	  searchPseudoElements: false,
	  observeMutations: true,
	  keepOriginalSource: true,
	  measurePerformance: false,
	  showMissingIcons: true
	}, initial);
	
	if (!_default.autoReplaceSvg) _default.observeMutations = false;
	
	var config$1 = _extends({}, _default);
	
	WINDOW.FontAwesomeConfig = config$1;
	
	function update(newConfig) {
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _params$asNewDefault = params.asNewDefault,
	      asNewDefault = _params$asNewDefault === undefined ? false : _params$asNewDefault;
	
	  var validKeys = Object.keys(config$1);
	  var ok = asNewDefault ? function (k) {
	    return ~validKeys.indexOf(k) && !~initialKeys.indexOf(k);
	  } : function (k) {
	    return ~validKeys.indexOf(k);
	  };
	
	  Object.keys(newConfig).forEach(function (configKey) {
	    if (ok(configKey)) config$1[configKey] = newConfig[configKey];
	  });
	}
	
	function auto(value) {
	  update({
	    autoReplaceSvg: value,
	    observeMutations: value
	  });
	}
	
	var w = WINDOW || {};
	
	if (!w[NAMESPACE_IDENTIFIER]) w[NAMESPACE_IDENTIFIER] = {};
	if (!w[NAMESPACE_IDENTIFIER].styles) w[NAMESPACE_IDENTIFIER].styles = {};
	if (!w[NAMESPACE_IDENTIFIER].hooks) w[NAMESPACE_IDENTIFIER].hooks = {};
	if (!w[NAMESPACE_IDENTIFIER].shims) w[NAMESPACE_IDENTIFIER].shims = [];
	
	var namespace = w[NAMESPACE_IDENTIFIER];
	
	var functions = [];
	var listener = function listener() {
	  DOCUMENT.removeEventListener('DOMContentLoaded', listener);
	  loaded = 1;
	  functions.map(function (fn) {
	    return fn();
	  });
	};
	
	var loaded = false;
	
	if (IS_DOM) {
	  loaded = (DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(DOCUMENT.readyState);
	
	  if (!loaded) DOCUMENT.addEventListener('DOMContentLoaded', listener);
	}
	
	var domready = function (fn) {
	  if (!IS_DOM) return;
	  loaded ? setTimeout(fn, 0) : functions.push(fn);
	};
	
	var d = UNITS_IN_GRID;
	
	var meaninglessTransform = {
	  size: 16,
	  x: 0,
	  y: 0,
	  rotate: 0,
	  flipX: false,
	  flipY: false
	};
	
	function isReserved(name) {
	  return ~RESERVED_CLASSES.indexOf(name);
	}
	
	function bunker(fn) {
	  try {
	    fn();
	  } catch (e) {
	    if (!PRODUCTION) {
	      throw e;
	    }
	  }
	}
	
	function insertCss(css) {
	  if (!css || !IS_DOM) {
	    return;
	  }
	
	  var style = DOCUMENT.createElement('style');
	  style.setAttribute('type', 'text/css');
	  style.innerHTML = css;
	
	  var headChildren = DOCUMENT.head.childNodes;
	  var beforeChild = null;
	
	  for (var i = headChildren.length - 1; i > -1; i--) {
	    var child = headChildren[i];
	    var tagName = (child.tagName || '').toUpperCase();
	    if (['STYLE', 'LINK'].indexOf(tagName) > -1) {
	      beforeChild = child;
	    }
	  }
	
	  DOCUMENT.head.insertBefore(style, beforeChild);
	
	  return css;
	}
	
	var _uniqueId = 0;
	
	function nextUniqueId() {
	  _uniqueId++;
	
	  return _uniqueId;
	}
	
	function toArray(obj) {
	  var array = [];
	
	  for (var i = (obj || []).length >>> 0; i--;) {
	    array[i] = obj[i];
	  }
	
	  return array;
	}
	
	function classArray(node) {
	  if (node.classList) {
	    return toArray(node.classList);
	  } else {
	    return (node.getAttribute('class') || '').split(' ').filter(function (i) {
	      return i;
	    });
	  }
	}
	
	function getIconName(familyPrefix, cls) {
	  var parts = cls.split('-');
	  var prefix = parts[0];
	  var iconName = parts.slice(1).join('-');
	
	  if (prefix === familyPrefix && iconName !== '' && !isReserved(iconName)) {
	    return iconName;
	  } else {
	    return null;
	  }
	}
	
	function htmlEscape(str) {
	  return ('' + str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
	}
	
	function joinAttributes(attributes) {
	  return Object.keys(attributes || {}).reduce(function (acc, attributeName) {
	    return acc + (attributeName + '="' + htmlEscape(attributes[attributeName]) + '" ');
	  }, '').trim();
	}
	
	function joinStyles(styles) {
	  return Object.keys(styles || {}).reduce(function (acc, styleName) {
	    return acc + (styleName + ': ' + styles[styleName] + ';');
	  }, '');
	}
	
	function transformIsMeaningful(transform) {
	  return transform.size !== meaninglessTransform.size || transform.x !== meaninglessTransform.x || transform.y !== meaninglessTransform.y || transform.rotate !== meaninglessTransform.rotate || transform.flipX || transform.flipY;
	}
	
	function transformForSvg(_ref) {
	  var transform = _ref.transform,
	      containerWidth = _ref.containerWidth,
	      iconWidth = _ref.iconWidth;
	
	  var outer = {
	    transform: 'translate(' + containerWidth / 2 + ' 256)'
	  };
	  var innerTranslate = 'translate(' + transform.x * 32 + ', ' + transform.y * 32 + ') ';
	  var innerScale = 'scale(' + transform.size / 16 * (transform.flipX ? -1 : 1) + ', ' + transform.size / 16 * (transform.flipY ? -1 : 1) + ') ';
	  var innerRotate = 'rotate(' + transform.rotate + ' 0 0)';
	  var inner = {
	    transform: innerTranslate + ' ' + innerScale + ' ' + innerRotate
	  };
	  var path = {
	    transform: 'translate(' + iconWidth / 2 * -1 + ' -256)'
	  };
	  return {
	    outer: outer,
	    inner: inner,
	    path: path
	  };
	}
	
	function transformForCss(_ref2) {
	  var transform = _ref2.transform,
	      _ref2$width = _ref2.width,
	      width = _ref2$width === undefined ? UNITS_IN_GRID : _ref2$width,
	      _ref2$height = _ref2.height,
	      height = _ref2$height === undefined ? UNITS_IN_GRID : _ref2$height,
	      _ref2$startCentered = _ref2.startCentered,
	      startCentered = _ref2$startCentered === undefined ? false : _ref2$startCentered;
	
	  var val = '';
	
	  if (startCentered && IS_IE) {
	    val += 'translate(' + (transform.x / d - width / 2) + 'em, ' + (transform.y / d - height / 2) + 'em) ';
	  } else if (startCentered) {
	    val += 'translate(calc(-50% + ' + transform.x / d + 'em), calc(-50% + ' + transform.y / d + 'em)) ';
	  } else {
	    val += 'translate(' + transform.x / d + 'em, ' + transform.y / d + 'em) ';
	  }
	
	  val += 'scale(' + transform.size / d * (transform.flipX ? -1 : 1) + ', ' + transform.size / d * (transform.flipY ? -1 : 1) + ') ';
	  val += 'rotate(' + transform.rotate + 'deg) ';
	
	  return val;
	}
	
	var ALL_SPACE = {
	  x: 0,
	  y: 0,
	  width: '100%',
	  height: '100%'
	};
	
	var makeIconMasking = function (_ref) {
	  var children = _ref.children,
	      attributes = _ref.attributes,
	      main = _ref.main,
	      mask = _ref.mask,
	      transform = _ref.transform;
	  var mainWidth = main.width,
	      mainPath = main.icon;
	  var maskWidth = mask.width,
	      maskPath = mask.icon;
	
	
	  var trans = transformForSvg({ transform: transform, containerWidth: maskWidth, iconWidth: mainWidth });
	
	  var maskRect = {
	    tag: 'rect',
	    attributes: _extends({}, ALL_SPACE, {
	      fill: 'white'
	    })
	  };
	  var maskInnerGroup = {
	    tag: 'g',
	    attributes: _extends({}, trans.inner),
	    children: [{ tag: 'path', attributes: _extends({}, mainPath.attributes, trans.path, { fill: 'black' }) }]
	  };
	  var maskOuterGroup = {
	    tag: 'g',
	    attributes: _extends({}, trans.outer),
	    children: [maskInnerGroup]
	  };
	  var maskId = 'mask-' + nextUniqueId();
	  var clipId = 'clip-' + nextUniqueId();
	  var maskTag = {
	    tag: 'mask',
	    attributes: _extends({}, ALL_SPACE, {
	      id: maskId,
	      maskUnits: 'userSpaceOnUse',
	      maskContentUnits: 'userSpaceOnUse'
	    }),
	    children: [maskRect, maskOuterGroup]
	  };
	  var defs = {
	    tag: 'defs',
	    children: [{ tag: 'clipPath', attributes: { id: clipId }, children: [maskPath] }, maskTag]
	  };
	
	  children.push(defs, { tag: 'rect', attributes: _extends({ fill: 'currentColor', 'clip-path': 'url(#' + clipId + ')', mask: 'url(#' + maskId + ')' }, ALL_SPACE) });
	
	  return {
	    children: children,
	    attributes: attributes
	  };
	};
	
	var makeIconStandard = function (_ref) {
	  var children = _ref.children,
	      attributes = _ref.attributes,
	      main = _ref.main,
	      transform = _ref.transform,
	      styles = _ref.styles;
	
	  var styleString = joinStyles(styles);
	
	  if (styleString.length > 0) {
	    attributes['style'] = styleString;
	  }
	
	  if (transformIsMeaningful(transform)) {
	    var trans = transformForSvg({ transform: transform, containerWidth: main.width, iconWidth: main.width });
	    children.push({
	      tag: 'g',
	      attributes: _extends({}, trans.outer),
	      children: [{
	        tag: 'g',
	        attributes: _extends({}, trans.inner),
	        children: [{
	          tag: main.icon.tag,
	          children: main.icon.children,
	          attributes: _extends({}, main.icon.attributes, trans.path)
	        }]
	      }]
	    });
	  } else {
	    children.push(main.icon);
	  }
	
	  return {
	    children: children,
	    attributes: attributes
	  };
	};
	
	var asIcon = function (_ref) {
	  var children = _ref.children,
	      main = _ref.main,
	      mask = _ref.mask,
	      attributes = _ref.attributes,
	      styles = _ref.styles,
	      transform = _ref.transform;
	
	  if (transformIsMeaningful(transform) && main.found && !mask.found) {
	    var width = main.width,
	        height = main.height;
	
	    var offset = {
	      x: width / height / 2,
	      y: 0.5
	    };
	    attributes['style'] = joinStyles(_extends({}, styles, {
	      'transform-origin': offset.x + transform.x / 16 + 'em ' + (offset.y + transform.y / 16) + 'em'
	    }));
	  }
	
	  return [{
	    tag: 'svg',
	    attributes: attributes,
	    children: children
	  }];
	};
	
	var asSymbol = function (_ref) {
	  var prefix = _ref.prefix,
	      iconName = _ref.iconName,
	      children = _ref.children,
	      attributes = _ref.attributes,
	      symbol = _ref.symbol;
	
	  var id = symbol === true ? prefix + '-' + config$1.familyPrefix + '-' + iconName : symbol;
	
	  return [{
	    tag: 'svg',
	    attributes: {
	      style: 'display: none;'
	    },
	    children: [{
	      tag: 'symbol',
	      attributes: _extends({}, attributes, { id: id }),
	      children: children
	    }]
	  }];
	};
	
	function makeInlineSvgAbstract(params) {
	  var _params$icons = params.icons,
	      main = _params$icons.main,
	      mask = _params$icons.mask,
	      prefix = params.prefix,
	      iconName = params.iconName,
	      transform = params.transform,
	      symbol = params.symbol,
	      title = params.title,
	      extra = params.extra,
	      _params$watchable = params.watchable,
	      watchable = _params$watchable === undefined ? false : _params$watchable;
	
	  var _ref = mask.found ? mask : main,
	      width = _ref.width,
	      height = _ref.height;
	
	  var widthClass = 'fa-w-' + Math.ceil(width / height * 16);
	  var attrClass = [config$1.replacementClass, iconName ? config$1.familyPrefix + '-' + iconName : '', widthClass].concat(extra.classes).join(' ');
	
	  var content = {
	    children: [],
	    attributes: _extends({}, extra.attributes, {
	      'data-prefix': prefix,
	      'data-icon': iconName,
	      'class': attrClass,
	      'role': 'img',
	      'xmlns': 'http://www.w3.org/2000/svg',
	      'viewBox': '0 0 ' + width + ' ' + height
	    })
	  };
	
	  if (watchable) {
	    content.attributes[DATA_FA_I2SVG] = '';
	  }
	
	  if (title) content.children.push({ tag: 'title', attributes: { id: content.attributes['aria-labelledby'] || 'title-' + nextUniqueId() }, children: [title] });
	
	  var args = _extends({}, content, {
	    prefix: prefix,
	    iconName: iconName,
	    main: main,
	    mask: mask,
	    transform: transform,
	    symbol: symbol,
	    styles: extra.styles
	  });
	
	  var _ref2 = mask.found && main.found ? makeIconMasking(args) : makeIconStandard(args),
	      children = _ref2.children,
	      attributes = _ref2.attributes;
	
	  args.children = children;
	  args.attributes = attributes;
	
	  if (symbol) {
	    return asSymbol(args);
	  } else {
	    return asIcon(args);
	  }
	}
	
	function makeLayersTextAbstract(params) {
	  var content = params.content,
	      width = params.width,
	      height = params.height,
	      transform = params.transform,
	      title = params.title,
	      extra = params.extra,
	      _params$watchable2 = params.watchable,
	      watchable = _params$watchable2 === undefined ? false : _params$watchable2;
	
	
	  var attributes = _extends({}, extra.attributes, title ? { 'title': title } : {}, {
	    'class': extra.classes.join(' ')
	  });
	
	  if (watchable) {
	    attributes[DATA_FA_I2SVG] = '';
	  }
	
	  var styles = _extends({}, extra.styles);
	
	  if (transformIsMeaningful(transform)) {
	    styles['transform'] = transformForCss({ transform: transform, startCentered: true, width: width, height: height });
	    styles['-webkit-transform'] = styles['transform'];
	  }
	
	  var styleString = joinStyles(styles);
	
	  if (styleString.length > 0) {
	    attributes['style'] = styleString;
	  }
	
	  var val = [];
	
	  val.push({
	    tag: 'span',
	    attributes: attributes,
	    children: [content]
	  });
	
	  if (title) {
	    val.push({ tag: 'span', attributes: { class: 'sr-only' }, children: [title] });
	  }
	
	  return val;
	}
	
	var noop$2 = function noop() {};
	var p = config$1.measurePerformance && PERFORMANCE && PERFORMANCE.mark && PERFORMANCE.measure ? PERFORMANCE : { mark: noop$2, measure: noop$2 };
	var preamble = 'FA "5.0.13"';
	
	var begin = function begin(name) {
	  p.mark(preamble + ' ' + name + ' begins');
	  return function () {
	    return end(name);
	  };
	};
	
	var end = function end(name) {
	  p.mark(preamble + ' ' + name + ' ends');
	  p.measure(preamble + ' ' + name, preamble + ' ' + name + ' begins', preamble + ' ' + name + ' ends');
	};
	
	var perf = { begin: begin, end: end };
	
	'use strict';
	
	/**
	 * Internal helper to bind a function known to have 4 arguments
	 * to a given context.
	 */
	var bindInternal4 = function bindInternal4 (func, thisContext) {
	  return function (a, b, c, d) {
	    return func.call(thisContext, a, b, c, d);
	  };
	};
	
	'use strict';
	
	
	
	/**
	 * # Reduce
	 *
	 * A fast object `.reduce()` implementation.
	 *
	 * @param  {Object}   subject      The object to reduce over.
	 * @param  {Function} fn           The reducer function.
	 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
	 * @param  {Object}   thisContext  The context for the reducer.
	 * @return {mixed}                 The final result.
	 */
	var reduce = function fastReduceObject (subject, fn, initialValue, thisContext) {
	  var keys = Object.keys(subject),
	      length = keys.length,
	      iterator = thisContext !== undefined ? bindInternal4(fn, thisContext) : fn,
	      i, key, result;
	
	  if (initialValue === undefined) {
	    i = 1;
	    result = subject[keys[0]];
	  }
	  else {
	    i = 0;
	    result = initialValue;
	  }
	
	  for (; i < length; i++) {
	    key = keys[i];
	    result = iterator(result, subject[key], key, subject);
	  }
	
	  return result;
	};
	
	var styles$2 = namespace.styles;
	var shims = namespace.shims;
	
	
	var _byUnicode = {};
	var _byLigature = {};
	var _byOldName = {};
	
	var build = function build() {
	  var lookup = function lookup(reducer) {
	    return reduce(styles$2, function (o, style, prefix) {
	      o[prefix] = reduce(style, reducer, {});
	      return o;
	    }, {});
	  };
	
	  _byUnicode = lookup(function (acc, icon, iconName) {
	    acc[icon[3]] = iconName;
	
	    return acc;
	  });
	
	  _byLigature = lookup(function (acc, icon, iconName) {
	    var ligatures = icon[2];
	
	    acc[iconName] = iconName;
	
	    ligatures.forEach(function (ligature) {
	      acc[ligature] = iconName;
	    });
	
	    return acc;
	  });
	
	  var hasRegular = 'far' in styles$2;
	
	  _byOldName = reduce(shims, function (acc, shim) {
	    var oldName = shim[0];
	    var prefix = shim[1];
	    var iconName = shim[2];
	
	    if (prefix === 'far' && !hasRegular) {
	      prefix = 'fas';
	    }
	
	    acc[oldName] = { prefix: prefix, iconName: iconName };
	
	    return acc;
	  }, {});
	};
	
	build();
	
	function byUnicode(prefix, unicode) {
	  return _byUnicode[prefix][unicode];
	}
	
	function byLigature(prefix, ligature) {
	  return _byLigature[prefix][ligature];
	}
	
	function byOldName(name) {
	  return _byOldName[name] || { prefix: null, iconName: null };
	}
	
	var styles$1 = namespace.styles;
	
	
	var emptyCanonicalIcon = function emptyCanonicalIcon() {
	  return { prefix: null, iconName: null, rest: [] };
	};
	
	function getCanonicalIcon(values) {
	  return values.reduce(function (acc, cls) {
	    var iconName = getIconName(config$1.familyPrefix, cls);
	
	    if (styles$1[cls]) {
	      acc.prefix = cls;
	    } else if (iconName) {
	      var shim = acc.prefix === 'fa' ? byOldName(iconName) : {};
	
	      acc.iconName = shim.iconName || iconName;
	      acc.prefix = shim.prefix || acc.prefix;
	    } else if (cls !== config$1.replacementClass && cls.indexOf('fa-w-') !== 0) {
	      acc.rest.push(cls);
	    }
	
	    return acc;
	  }, emptyCanonicalIcon());
	}
	
	function iconFromMapping(mapping, prefix, iconName) {
	  if (mapping && mapping[prefix] && mapping[prefix][iconName]) {
	    return {
	      prefix: prefix,
	      iconName: iconName,
	      icon: mapping[prefix][iconName]
	    };
	  }
	}
	
	function toHtml(abstractNodes) {
	  var tag = abstractNodes.tag,
	      _abstractNodes$attrib = abstractNodes.attributes,
	      attributes = _abstractNodes$attrib === undefined ? {} : _abstractNodes$attrib,
	      _abstractNodes$childr = abstractNodes.children,
	      children = _abstractNodes$childr === undefined ? [] : _abstractNodes$childr;
	
	
	  if (typeof abstractNodes === 'string') {
	    return htmlEscape(abstractNodes);
	  } else {
	    return '<' + tag + ' ' + joinAttributes(attributes) + '>' + children.map(toHtml).join('') + '</' + tag + '>';
	  }
	}
	
	var noop$1 = function noop() {};
	
	function isWatched(node) {
	  var i2svg = node.getAttribute ? node.getAttribute(DATA_FA_I2SVG) : null;
	
	  return typeof i2svg === 'string';
	}
	
	function getMutator() {
	  if (config$1.autoReplaceSvg === true) {
	    return mutators.replace;
	  }
	
	  var mutator = mutators[config$1.autoReplaceSvg];
	
	  return mutator || mutators.replace;
	}
	
	var mutators = {
	  replace: function replace(mutation) {
	    var node = mutation[0];
	    var abstract = mutation[1];
	    var newOuterHTML = abstract.map(function (a) {
	      return toHtml(a);
	    }).join('\n');
	
	    if (node.parentNode && node.outerHTML) {
	      node.outerHTML = newOuterHTML + (config$1.keepOriginalSource && node.tagName.toLowerCase() !== 'svg' ? '<!-- ' + node.outerHTML + ' -->' : '');
	    } else if (node.parentNode) {
	      var newNode = document.createElement('span');
	      node.parentNode.replaceChild(newNode, node);
	      newNode.outerHTML = newOuterHTML;
	    }
	  },
	  nest: function nest(mutation) {
	    var node = mutation[0];
	    var abstract = mutation[1];
	
	    // If we already have a replaced node we do not want to continue nesting within it.
	    // Short-circuit to the standard replacement
	    if (~classArray(node).indexOf(config$1.replacementClass)) {
	      return mutators.replace(mutation);
	    }
	
	    var forSvg = new RegExp(config$1.familyPrefix + '-.*');
	
	    delete abstract[0].attributes.style;
	
	    var splitClasses = abstract[0].attributes.class.split(' ').reduce(function (acc, cls) {
	      if (cls === config$1.replacementClass || cls.match(forSvg)) {
	        acc.toSvg.push(cls);
	      } else {
	        acc.toNode.push(cls);
	      }
	
	      return acc;
	    }, { toNode: [], toSvg: [] });
	
	    abstract[0].attributes.class = splitClasses.toSvg.join(' ');
	
	    var newInnerHTML = abstract.map(function (a) {
	      return toHtml(a);
	    }).join('\n');
	    node.setAttribute('class', splitClasses.toNode.join(' '));
	    node.setAttribute(DATA_FA_I2SVG, '');
	    node.innerHTML = newInnerHTML;
	  }
	};
	
	function perform(mutations, callback) {
	  var callbackFunction = typeof callback === 'function' ? callback : noop$1;
	
	  if (mutations.length === 0) {
	    callbackFunction();
	  } else {
	    var frame = WINDOW.requestAnimationFrame || function (op) {
	      return op();
	    };
	
	    frame(function () {
	      var mutator = getMutator();
	      var mark = perf.begin('mutate');
	
	      mutations.map(mutator);
	
	      mark();
	
	      callbackFunction();
	    });
	  }
	}
	
	var disabled = false;
	
	function disableObservation(operation) {
	  disabled = true;
	  operation();
	  disabled = false;
	}
	
	var mo = null;
	
	function observe(options) {
	  if (!MUTATION_OBSERVER) return;
	
	  var treeCallback = options.treeCallback,
	      nodeCallback = options.nodeCallback,
	      pseudoElementsCallback = options.pseudoElementsCallback;
	
	
	  mo = new MUTATION_OBSERVER(function (objects) {
	    if (disabled) return;
	
	    toArray(objects).forEach(function (mutationRecord) {
	      if (mutationRecord.type === 'childList' && mutationRecord.addedNodes.length > 0 && !isWatched(mutationRecord.addedNodes[0])) {
	        if (config$1.searchPseudoElements) {
	          pseudoElementsCallback(mutationRecord.target);
	        }
	
	        treeCallback(mutationRecord.target);
	      }
	
	      if (mutationRecord.type === 'attributes' && mutationRecord.target.parentNode && config$1.searchPseudoElements) {
	        pseudoElementsCallback(mutationRecord.target.parentNode);
	      }
	
	      if (mutationRecord.type === 'attributes' && isWatched(mutationRecord.target) && ~ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
	        if (mutationRecord.attributeName === 'class') {
	          var _getCanonicalIcon = getCanonicalIcon(classArray(mutationRecord.target)),
	              prefix = _getCanonicalIcon.prefix,
	              iconName = _getCanonicalIcon.iconName;
	
	          if (prefix) mutationRecord.target.setAttribute('data-prefix', prefix);
	          if (iconName) mutationRecord.target.setAttribute('data-icon', iconName);
	        } else {
	          nodeCallback(mutationRecord.target);
	        }
	      }
	    });
	  });
	
	  if (!IS_DOM) return;
	
	  mo.observe(DOCUMENT.getElementsByTagName('body')[0], {
	    childList: true, attributes: true, characterData: true, subtree: true
	  });
	}
	
	function disconnect() {
	  if (!mo) return;
	
	  mo.disconnect();
	}
	
	var styleParser = function (node) {
	  var style = node.getAttribute('style');
	
	  var val = [];
	
	  if (style) {
	    val = style.split(';').reduce(function (acc, style) {
	      var styles = style.split(':');
	      var prop = styles[0];
	      var value = styles.slice(1);
	
	      if (prop && value.length > 0) {
	        acc[prop] = value.join(':').trim();
	      }
	
	      return acc;
	    }, {});
	  }
	
	  return val;
	};
	
	function toHex(unicode) {
	  var result = '';
	
	  for (var i = 0; i < unicode.length; i++) {
	    var hex = unicode.charCodeAt(i).toString(16);
	    result += ('000' + hex).slice(-4);
	  }
	
	  return result;
	}
	
	var classParser = function (node) {
	  var existingPrefix = node.getAttribute('data-prefix');
	  var existingIconName = node.getAttribute('data-icon');
	  var innerText = node.innerText !== undefined ? node.innerText.trim() : '';
	
	  var val = getCanonicalIcon(classArray(node));
	
	  if (existingPrefix && existingIconName) {
	    val.prefix = existingPrefix;
	    val.iconName = existingIconName;
	  }
	
	  if (val.prefix && innerText.length > 1) {
	    val.iconName = byLigature(val.prefix, node.innerText);
	  } else if (val.prefix && innerText.length === 1) {
	    val.iconName = byUnicode(val.prefix, toHex(node.innerText));
	  }
	
	  return val;
	};
	
	var parseTransformString = function parseTransformString(transformString) {
	  var transform = {
	    size: 16,
	    x: 0,
	    y: 0,
	    flipX: false,
	    flipY: false,
	    rotate: 0
	  };
	
	  if (!transformString) {
	    return transform;
	  } else {
	    return transformString.toLowerCase().split(' ').reduce(function (acc, n) {
	      var parts = n.toLowerCase().split('-');
	      var first = parts[0];
	      var rest = parts.slice(1).join('-');
	
	      if (first && rest === 'h') {
	        acc.flipX = true;
	        return acc;
	      }
	
	      if (first && rest === 'v') {
	        acc.flipY = true;
	        return acc;
	      }
	
	      rest = parseFloat(rest);
	
	      if (isNaN(rest)) {
	        return acc;
	      }
	
	      switch (first) {
	        case 'grow':
	          acc.size = acc.size + rest;
	          break;
	        case 'shrink':
	          acc.size = acc.size - rest;
	          break;
	        case 'left':
	          acc.x = acc.x - rest;
	          break;
	        case 'right':
	          acc.x = acc.x + rest;
	          break;
	        case 'up':
	          acc.y = acc.y - rest;
	          break;
	        case 'down':
	          acc.y = acc.y + rest;
	          break;
	        case 'rotate':
	          acc.rotate = acc.rotate + rest;
	          break;
	      }
	
	      return acc;
	    }, transform);
	  }
	};
	
	var transformParser = function (node) {
	  return parseTransformString(node.getAttribute('data-fa-transform'));
	};
	
	var symbolParser = function (node) {
	  var symbol = node.getAttribute('data-fa-symbol');
	
	  return symbol === null ? false : symbol === '' ? true : symbol;
	};
	
	var attributesParser = function (node) {
	  var extraAttributes = toArray(node.attributes).reduce(function (acc, attr) {
	    if (acc.name !== 'class' && acc.name !== 'style') {
	      acc[attr.name] = attr.value;
	    }
	    return acc;
	  }, {});
	
	  var title = node.getAttribute('title');
	
	  if (config$1.autoA11y) {
	    if (title) {
	      extraAttributes['aria-labelledby'] = config$1.replacementClass + '-title-' + nextUniqueId();
	    } else {
	      extraAttributes['aria-hidden'] = 'true';
	    }
	  }
	
	  return extraAttributes;
	};
	
	var maskParser = function (node) {
	  var mask = node.getAttribute('data-fa-mask');
	
	  if (!mask) {
	    return emptyCanonicalIcon();
	  } else {
	    return getCanonicalIcon(mask.split(' ').map(function (i) {
	      return i.trim();
	    }));
	  }
	};
	
	function parseMeta(node) {
	  var _classParser = classParser(node),
	      iconName = _classParser.iconName,
	      prefix = _classParser.prefix,
	      extraClasses = _classParser.rest;
	
	  var extraStyles = styleParser(node);
	  var transform = transformParser(node);
	  var symbol = symbolParser(node);
	  var extraAttributes = attributesParser(node);
	  var mask = maskParser(node);
	
	  return {
	    iconName: iconName,
	    title: node.getAttribute('title'),
	    prefix: prefix,
	    transform: transform,
	    symbol: symbol,
	    mask: mask,
	    extra: {
	      classes: extraClasses,
	      styles: extraStyles,
	      attributes: extraAttributes
	    }
	  };
	}
	
	function MissingIcon(error) {
	  this.name = 'MissingIcon';
	  this.message = error || 'Icon unavailable';
	  this.stack = new Error().stack;
	}
	
	MissingIcon.prototype = Object.create(Error.prototype);
	MissingIcon.prototype.constructor = MissingIcon;
	
	var FILL = { fill: 'currentColor' };
	var ANIMATION_BASE = {
	  attributeType: 'XML',
	  repeatCount: 'indefinite',
	  dur: '2s'
	};
	var RING = {
	  tag: 'path',
	  attributes: _extends({}, FILL, {
	    d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
	  })
	};
	var OPACITY_ANIMATE = _extends({}, ANIMATION_BASE, {
	  attributeName: 'opacity'
	});
	var DOT = {
	  tag: 'circle',
	  attributes: _extends({}, FILL, {
	    cx: '256',
	    cy: '364',
	    r: '28'
	  }),
	  children: [{ tag: 'animate', attributes: _extends({}, ANIMATION_BASE, { attributeName: 'r', values: '28;14;28;28;14;28;' }) }, { tag: 'animate', attributes: _extends({}, OPACITY_ANIMATE, { values: '1;0;1;1;0;1;' }) }]
	};
	var QUESTION = {
	  tag: 'path',
	  attributes: _extends({}, FILL, {
	    opacity: '1',
	    d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
	  }),
	  children: [{ tag: 'animate', attributes: _extends({}, OPACITY_ANIMATE, { values: '1;0;0;0;0;1;' }) }]
	};
	var EXCLAMATION = {
	  tag: 'path',
	  attributes: _extends({}, FILL, {
	    opacity: '0',
	    d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
	  }),
	  children: [{ tag: 'animate', attributes: _extends({}, OPACITY_ANIMATE, { values: '0;0;1;1;0;0;' }) }]
	};
	
	var missing = { tag: 'g', children: [RING, DOT, QUESTION, EXCLAMATION] };
	
	var styles = namespace.styles;
	
	var LAYERS_TEXT_CLASSNAME = 'fa-layers-text';
	var FONT_FAMILY_PATTERN = /Font Awesome 5 (Solid|Regular|Light|Brands)/;
	var STYLE_TO_PREFIX = {
	  'Solid': 'fas',
	  'Regular': 'far',
	  'Light': 'fal',
	  'Brands': 'fab'
	};
	
	function findIcon(iconName, prefix) {
	  var val = {
	    found: false,
	    width: 512,
	    height: 512,
	    icon: missing
	  };
	
	  if (iconName && prefix && styles[prefix] && styles[prefix][iconName]) {
	    var icon = styles[prefix][iconName];
	    var width = icon[0];
	    var height = icon[1];
	    var vectorData = icon.slice(4);
	
	    val = {
	      found: true,
	      width: width,
	      height: height,
	      icon: { tag: 'path', attributes: { fill: 'currentColor', d: vectorData[0] } }
	    };
	  } else if (iconName && prefix && !config$1.showMissingIcons) {
	    throw new MissingIcon('Icon is missing for prefix ' + prefix + ' with icon name ' + iconName);
	  }
	
	  return val;
	}
	
	function generateSvgReplacementMutation(node, nodeMeta) {
	  var iconName = nodeMeta.iconName,
	      title = nodeMeta.title,
	      prefix = nodeMeta.prefix,
	      transform = nodeMeta.transform,
	      symbol = nodeMeta.symbol,
	      mask = nodeMeta.mask,
	      extra = nodeMeta.extra;
	
	
	  return [node, makeInlineSvgAbstract({
	    icons: {
	      main: findIcon(iconName, prefix),
	      mask: findIcon(mask.iconName, mask.prefix)
	    },
	    prefix: prefix,
	    iconName: iconName,
	    transform: transform,
	    symbol: symbol,
	    mask: mask,
	    title: title,
	    extra: extra,
	    watchable: true
	  })];
	}
	
	function generateLayersText(node, nodeMeta) {
	  var title = nodeMeta.title,
	      transform = nodeMeta.transform,
	      extra = nodeMeta.extra;
	
	
	  var width = null;
	  var height = null;
	
	  if (IS_IE) {
	    var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
	    var boundingClientRect = node.getBoundingClientRect();
	    width = boundingClientRect.width / computedFontSize;
	    height = boundingClientRect.height / computedFontSize;
	  }
	
	  if (config$1.autoA11y && !title) {
	    extra.attributes['aria-hidden'] = 'true';
	  }
	
	  return [node, makeLayersTextAbstract({
	    content: node.innerHTML,
	    width: width,
	    height: height,
	    transform: transform,
	    title: title,
	    extra: extra,
	    watchable: true
	  })];
	}
	
	function generateMutation(node) {
	  var nodeMeta = parseMeta(node);
	
	  if (~nodeMeta.extra.classes.indexOf(LAYERS_TEXT_CLASSNAME)) {
	    return generateLayersText(node, nodeMeta);
	  } else {
	    return generateSvgReplacementMutation(node, nodeMeta);
	  }
	}
	
	function remove(node) {
	  if (typeof node.remove === 'function') {
	    node.remove();
	  } else if (node && node.parentNode) {
	    node.parentNode.removeChild(node);
	  }
	}
	
	function searchPseudoElements(root) {
	  if (!IS_DOM) return;
	
	  var end = perf.begin('searchPseudoElements');
	
	  disableObservation(function () {
	    toArray(root.querySelectorAll('*')).forEach(function (node) {
	      [':before', ':after'].forEach(function (pos) {
	        var styles = WINDOW.getComputedStyle(node, pos);
	        var fontFamily = styles.getPropertyValue('font-family').match(FONT_FAMILY_PATTERN);
	        var children = toArray(node.children);
	        var pseudoElement = children.filter(function (c) {
	          return c.getAttribute(DATA_FA_PSEUDO_ELEMENT) === pos;
	        })[0];
	
	        if (pseudoElement) {
	          if (pseudoElement.nextSibling && pseudoElement.nextSibling.textContent.indexOf(DATA_FA_PSEUDO_ELEMENT) > -1) {
	            remove(pseudoElement.nextSibling);
	          }
	          remove(pseudoElement);
	          pseudoElement = null;
	        }
	
	        if (fontFamily && !pseudoElement) {
	          var content = styles.getPropertyValue('content');
	          var i = DOCUMENT.createElement('i');
	          i.setAttribute('class', '' + STYLE_TO_PREFIX[fontFamily[1]]);
	          i.setAttribute(DATA_FA_PSEUDO_ELEMENT, pos);
	          i.innerText = content.length === 3 ? content.substr(1, 1) : content;
	          if (pos === ':before') {
	            node.insertBefore(i, node.firstChild);
	          } else {
	            node.appendChild(i);
	          }
	        }
	      });
	    });
	  });
	
	  end();
	}
	
	function onTree(root) {
	  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	  if (!IS_DOM) return;
	
	  var htmlClassList = DOCUMENT.documentElement.classList;
	  var hclAdd = function hclAdd(suffix) {
	    return htmlClassList.add(HTML_CLASS_I2SVG_BASE_CLASS + '-' + suffix);
	  };
	  var hclRemove = function hclRemove(suffix) {
	    return htmlClassList.remove(HTML_CLASS_I2SVG_BASE_CLASS + '-' + suffix);
	  };
	  var prefixes = Object.keys(styles);
	  var prefixesDomQuery = ['.' + LAYERS_TEXT_CLASSNAME + ':not([' + DATA_FA_I2SVG + '])'].concat(prefixes.map(function (p) {
	    return '.' + p + ':not([' + DATA_FA_I2SVG + '])';
	  })).join(', ');
	
	  if (prefixesDomQuery.length === 0) {
	    return;
	  }
	
	  var candidates = toArray(root.querySelectorAll(prefixesDomQuery));
	
	  if (candidates.length > 0) {
	    hclAdd('pending');
	    hclRemove('complete');
	  } else {
	    return;
	  }
	
	  var mark = perf.begin('onTree');
	
	  var mutations = candidates.reduce(function (acc, node) {
	    try {
	      var mutation = generateMutation(node);
	
	      if (mutation) {
	        acc.push(mutation);
	      }
	    } catch (e) {
	      if (!PRODUCTION) {
	        if (e instanceof MissingIcon) {
	          console.error(e);
	        }
	      }
	    }
	
	    return acc;
	  }, []);
	
	  mark();
	
	  perform(mutations, function () {
	    hclAdd('active');
	    hclAdd('complete');
	    hclRemove('pending');
	
	    if (typeof callback === 'function') callback();
	  });
	}
	
	function onNode(node) {
	  var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
	
	  var mutation = generateMutation(node);
	
	  if (mutation) {
	    perform([mutation], callback);
	  }
	}
	
	var baseStyles = "svg:not(:root).svg-inline--fa {\n  overflow: visible; }\n\n.svg-inline--fa {\n  display: inline-block;\n  font-size: inherit;\n  height: 1em;\n  overflow: visible;\n  vertical-align: -.125em; }\n  .svg-inline--fa.fa-lg {\n    vertical-align: -.225em; }\n  .svg-inline--fa.fa-w-1 {\n    width: 0.0625em; }\n  .svg-inline--fa.fa-w-2 {\n    width: 0.125em; }\n  .svg-inline--fa.fa-w-3 {\n    width: 0.1875em; }\n  .svg-inline--fa.fa-w-4 {\n    width: 0.25em; }\n  .svg-inline--fa.fa-w-5 {\n    width: 0.3125em; }\n  .svg-inline--fa.fa-w-6 {\n    width: 0.375em; }\n  .svg-inline--fa.fa-w-7 {\n    width: 0.4375em; }\n  .svg-inline--fa.fa-w-8 {\n    width: 0.5em; }\n  .svg-inline--fa.fa-w-9 {\n    width: 0.5625em; }\n  .svg-inline--fa.fa-w-10 {\n    width: 0.625em; }\n  .svg-inline--fa.fa-w-11 {\n    width: 0.6875em; }\n  .svg-inline--fa.fa-w-12 {\n    width: 0.75em; }\n  .svg-inline--fa.fa-w-13 {\n    width: 0.8125em; }\n  .svg-inline--fa.fa-w-14 {\n    width: 0.875em; }\n  .svg-inline--fa.fa-w-15 {\n    width: 0.9375em; }\n  .svg-inline--fa.fa-w-16 {\n    width: 1em; }\n  .svg-inline--fa.fa-w-17 {\n    width: 1.0625em; }\n  .svg-inline--fa.fa-w-18 {\n    width: 1.125em; }\n  .svg-inline--fa.fa-w-19 {\n    width: 1.1875em; }\n  .svg-inline--fa.fa-w-20 {\n    width: 1.25em; }\n  .svg-inline--fa.fa-pull-left {\n    margin-right: .3em;\n    width: auto; }\n  .svg-inline--fa.fa-pull-right {\n    margin-left: .3em;\n    width: auto; }\n  .svg-inline--fa.fa-border {\n    height: 1.5em; }\n  .svg-inline--fa.fa-li {\n    width: 2em; }\n  .svg-inline--fa.fa-fw {\n    width: 1.25em; }\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0; }\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -.125em;\n  width: 1em; }\n  .fa-layers svg.svg-inline--fa {\n    -webkit-transform-origin: center center;\n            transform-origin: center center; }\n\n.fa-layers-text, .fa-layers-counter {\n  display: inline-block;\n  position: absolute;\n  text-align: center; }\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  -webkit-transform-origin: center center;\n          transform-origin: center center; }\n\n.fa-layers-counter {\n  background-color: #ff253a;\n  border-radius: 1em;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  color: #fff;\n  height: 1.5em;\n  line-height: 1;\n  max-width: 5em;\n  min-width: 1.5em;\n  overflow: hidden;\n  padding: .25em;\n  right: 0;\n  text-overflow: ellipsis;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right; }\n\n.fa-layers-bottom-right {\n  bottom: 0;\n  right: 0;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom right;\n          transform-origin: bottom right; }\n\n.fa-layers-bottom-left {\n  bottom: 0;\n  left: 0;\n  right: auto;\n  top: auto;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: bottom left;\n          transform-origin: bottom left; }\n\n.fa-layers-top-right {\n  right: 0;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top right;\n          transform-origin: top right; }\n\n.fa-layers-top-left {\n  left: 0;\n  right: auto;\n  top: 0;\n  -webkit-transform: scale(0.25);\n          transform: scale(0.25);\n  -webkit-transform-origin: top left;\n          transform-origin: top left; }\n\n.fa-lg {\n  font-size: 1.33333em;\n  line-height: 0.75em;\n  vertical-align: -.0667em; }\n\n.fa-xs {\n  font-size: .75em; }\n\n.fa-sm {\n  font-size: .875em; }\n\n.fa-1x {\n  font-size: 1em; }\n\n.fa-2x {\n  font-size: 2em; }\n\n.fa-3x {\n  font-size: 3em; }\n\n.fa-4x {\n  font-size: 4em; }\n\n.fa-5x {\n  font-size: 5em; }\n\n.fa-6x {\n  font-size: 6em; }\n\n.fa-7x {\n  font-size: 7em; }\n\n.fa-8x {\n  font-size: 8em; }\n\n.fa-9x {\n  font-size: 9em; }\n\n.fa-10x {\n  font-size: 10em; }\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em; }\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: 2.5em;\n  padding-left: 0; }\n  .fa-ul > li {\n    position: relative; }\n\n.fa-li {\n  left: -2em;\n  position: absolute;\n  text-align: center;\n  width: 2em;\n  line-height: inherit; }\n\n.fa-border {\n  border: solid 0.08em #eee;\n  border-radius: .1em;\n  padding: .2em .25em .15em; }\n\n.fa-pull-left {\n  float: left; }\n\n.fa-pull-right {\n  float: right; }\n\n.fa.fa-pull-left,\n.fas.fa-pull-left,\n.far.fa-pull-left,\n.fal.fa-pull-left,\n.fab.fa-pull-left {\n  margin-right: .3em; }\n\n.fa.fa-pull-right,\n.fas.fa-pull-right,\n.far.fa-pull-right,\n.fal.fa-pull-right,\n.fab.fa-pull-right {\n  margin-left: .3em; }\n\n.fa-spin {\n  -webkit-animation: fa-spin 2s infinite linear;\n          animation: fa-spin 2s infinite linear; }\n\n.fa-pulse {\n  -webkit-animation: fa-spin 1s infinite steps(8);\n          animation: fa-spin 1s infinite steps(8); }\n\n@-webkit-keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n\n@keyframes fa-spin {\n  0% {\n    -webkit-transform: rotate(0deg);\n            transform: rotate(0deg); }\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg); } }\n\n.fa-rotate-90 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg); }\n\n.fa-rotate-180 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg); }\n\n.fa-rotate-270 {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";\n  -webkit-transform: rotate(270deg);\n          transform: rotate(270deg); }\n\n.fa-flip-horizontal {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";\n  -webkit-transform: scale(-1, 1);\n          transform: scale(-1, 1); }\n\n.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(1, -1);\n          transform: scale(1, -1); }\n\n.fa-flip-horizontal.fa-flip-vertical {\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\n  -webkit-transform: scale(-1, -1);\n          transform: scale(-1, -1); }\n\n:root .fa-rotate-90,\n:root .fa-rotate-180,\n:root .fa-rotate-270,\n:root .fa-flip-horizontal,\n:root .fa-flip-vertical {\n  -webkit-filter: none;\n          filter: none; }\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  position: relative;\n  width: 2em; }\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0; }\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1em; }\n\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2em; }\n\n.fa-inverse {\n  color: #fff; }\n\n.sr-only {\n  border: 0;\n  clip: rect(0, 0, 0, 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  width: 1px; }\n\n.sr-only-focusable:active, .sr-only-focusable:focus {\n  clip: auto;\n  height: auto;\n  margin: 0;\n  overflow: visible;\n  position: static;\n  width: auto; }\n";
	
	var css = function () {
	  var dfp = DEFAULT_FAMILY_PREFIX;
	  var drc = DEFAULT_REPLACEMENT_CLASS;
	  var fp = config$1.familyPrefix;
	  var rc = config$1.replacementClass;
	  var s = baseStyles;
	
	  if (fp !== dfp || rc !== drc) {
	    var dPatt = new RegExp('\\.' + dfp + '\\-', 'g');
	    var rPatt = new RegExp('\\.' + drc, 'g');
	
	    s = s.replace(dPatt, '.' + fp + '-').replace(rPatt, '.' + rc);
	  }
	
	  return s;
	};
	
	function define(prefix, icons) {
	  var normalized = Object.keys(icons).reduce(function (acc, iconName) {
	    var icon = icons[iconName];
	    var expanded = !!icon.icon;
	
	    if (expanded) {
	      acc[icon.iconName] = icon.icon;
	    } else {
	      acc[iconName] = icon;
	    }
	    return acc;
	  }, {});
	
	  if (typeof namespace.hooks.addPack === 'function') {
	    namespace.hooks.addPack(prefix, normalized);
	  } else {
	    namespace.styles[prefix] = _extends({}, namespace.styles[prefix] || {}, normalized);
	  }
	
	  /**
	   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
	   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
	   * for `fas` so we'll easy the upgrade process for our users by automatically defining
	   * this as well.
	   */
	  if (prefix === 'fas') {
	    define('fa', icons);
	  }
	}
	
	var Library = function () {
	  function Library() {
	    classCallCheck(this, Library);
	
	    this.definitions = {};
	  }
	
	  createClass(Library, [{
	    key: 'add',
	    value: function add() {
	      var _this = this;
	
	      for (var _len = arguments.length, definitions = Array(_len), _key = 0; _key < _len; _key++) {
	        definitions[_key] = arguments[_key];
	      }
	
	      var additions = definitions.reduce(this._pullDefinitions, {});
	
	      Object.keys(additions).forEach(function (key) {
	        _this.definitions[key] = _extends({}, _this.definitions[key] || {}, additions[key]);
	        define(key, additions[key]);
	      });
	    }
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.definitions = {};
	    }
	  }, {
	    key: '_pullDefinitions',
	    value: function _pullDefinitions(additions, definition) {
	      var normalized = definition.prefix && definition.iconName && definition.icon ? { 0: definition } : definition;
	
	      Object.keys(normalized).map(function (key) {
	        var _normalized$key = normalized[key],
	            prefix = _normalized$key.prefix,
	            iconName = _normalized$key.iconName,
	            icon = _normalized$key.icon;
	
	
	        if (!additions[prefix]) additions[prefix] = {};
	
	        additions[prefix][iconName] = icon;
	      });
	
	      return additions;
	    }
	  }]);
	  return Library;
	}();
	
	function prepIcon(icon) {
	  var width = icon[0];
	  var height = icon[1];
	  var vectorData = icon.slice(4);
	
	  return {
	    found: true,
	    width: width,
	    height: height,
	    icon: { tag: 'path', attributes: { fill: 'currentColor', d: vectorData[0] } }
	  };
	}
	
	var _cssInserted = false;
	
	function ensureCss() {
	  if (!config$1.autoAddCss) {
	    return;
	  }
	
	  if (!_cssInserted) {
	    insertCss(css());
	  }
	
	  _cssInserted = true;
	}
	
	function apiObject(val, abstractCreator) {
	  Object.defineProperty(val, 'abstract', {
	    get: abstractCreator
	  });
	
	  Object.defineProperty(val, 'html', {
	    get: function get() {
	      return val.abstract.map(function (a) {
	        return toHtml(a);
	      });
	    }
	  });
	
	  Object.defineProperty(val, 'node', {
	    get: function get() {
	      if (!IS_DOM) return;
	
	      var container = DOCUMENT.createElement('div');
	      container.innerHTML = val.html;
	      return container.children;
	    }
	  });
	
	  return val;
	}
	
	function findIconDefinition(params) {
	  var _params$prefix = params.prefix,
	      prefix = _params$prefix === undefined ? 'fa' : _params$prefix,
	      iconName = params.iconName;
	
	
	  if (!iconName) return;
	
	  return iconFromMapping(library.definitions, prefix, iconName) || iconFromMapping(namespace.styles, prefix, iconName);
	}
	
	function resolveIcons(next) {
	  return function (maybeIconDefinition) {
	    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : findIconDefinition(maybeIconDefinition || {});
	
	    var mask = params.mask;
	
	
	    if (mask) {
	      mask = (mask || {}).icon ? mask : findIconDefinition(mask || {});
	    }
	
	    return next(iconDefinition, _extends({}, params, { mask: mask }));
	  };
	}
	
	var library = new Library();
	
	var noAuto = function noAuto() {
	  auto(false);
	  disconnect();
	};
	
	var dom = {
	  i2svg: function i2svg() {
	    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	    if (IS_DOM) {
	      ensureCss();
	
	      var _params$node = params.node,
	          node = _params$node === undefined ? DOCUMENT : _params$node,
	          _params$callback = params.callback,
	          callback = _params$callback === undefined ? function () {} : _params$callback;
	
	
	      if (config$1.searchPseudoElements) {
	        searchPseudoElements(node);
	      }
	
	      onTree(node, callback);
	    }
	  },
	
	  css: css,
	
	  insertCss: function insertCss$$1() {
	    insertCss(css());
	  }
	};
	
	var parse = {
	  transform: function transform(transformString) {
	    return parseTransformString(transformString);
	  }
	};
	
	var icon = resolveIcons(function (iconDefinition) {
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _params$transform = params.transform,
	      transform = _params$transform === undefined ? meaninglessTransform : _params$transform,
	      _params$symbol = params.symbol,
	      symbol = _params$symbol === undefined ? false : _params$symbol,
	      _params$mask = params.mask,
	      mask = _params$mask === undefined ? null : _params$mask,
	      _params$title = params.title,
	      title = _params$title === undefined ? null : _params$title,
	      _params$classes = params.classes,
	      classes = _params$classes === undefined ? [] : _params$classes,
	      _params$attributes = params.attributes,
	      attributes = _params$attributes === undefined ? {} : _params$attributes,
	      _params$styles = params.styles,
	      styles = _params$styles === undefined ? {} : _params$styles;
	
	
	  if (!iconDefinition) return;
	
	  var prefix = iconDefinition.prefix,
	      iconName = iconDefinition.iconName,
	      icon = iconDefinition.icon;
	
	
	  return apiObject(_extends({ type: 'icon' }, iconDefinition), function () {
	    ensureCss();
	
	    if (config$1.autoA11y) {
	      if (title) {
	        attributes['aria-labelledby'] = config$1.replacementClass + '-title-' + nextUniqueId();
	      } else {
	        attributes['aria-hidden'] = 'true';
	      }
	    }
	
	    return makeInlineSvgAbstract({
	      icons: {
	        main: prepIcon(icon),
	        mask: mask ? prepIcon(mask.icon) : { found: false, width: null, height: null, icon: {} }
	      },
	      prefix: prefix,
	      iconName: iconName,
	      transform: _extends({}, meaninglessTransform, transform),
	      symbol: symbol,
	      title: title,
	      extra: {
	        attributes: attributes,
	        styles: styles,
	        classes: classes
	      }
	    });
	  });
	});
	
	var text = function text(content) {
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _params$transform2 = params.transform,
	      transform = _params$transform2 === undefined ? meaninglessTransform : _params$transform2,
	      _params$title2 = params.title,
	      title = _params$title2 === undefined ? null : _params$title2,
	      _params$classes2 = params.classes,
	      classes = _params$classes2 === undefined ? [] : _params$classes2,
	      _params$attributes2 = params.attributes,
	      attributes = _params$attributes2 === undefined ? {} : _params$attributes2,
	      _params$styles2 = params.styles,
	      styles = _params$styles2 === undefined ? {} : _params$styles2;
	
	
	  return apiObject({ type: 'text', content: content }, function () {
	    ensureCss();
	
	    return makeLayersTextAbstract({
	      content: content,
	      transform: _extends({}, meaninglessTransform, transform),
	      title: title,
	      extra: {
	        attributes: attributes,
	        styles: styles,
	        classes: [config$1.familyPrefix + '-layers-text'].concat(toConsumableArray(classes))
	      }
	    });
	  });
	};
	
	var layer = function layer(assembler) {
	  return apiObject({ type: 'layer' }, function () {
	    ensureCss();
	
	    var children = [];
	
	    assembler(function (args) {
	      Array.isArray(args) ? args.map(function (a) {
	        children = children.concat(a.abstract);
	      }) : children = children.concat(args.abstract);
	    });
	
	    return [{
	      tag: 'span',
	      attributes: { class: config$1.familyPrefix + '-layers' },
	      children: children
	    }];
	  });
	};
	
	var api$1 = {
	  noAuto: noAuto,
	  dom: dom,
	  library: library,
	  parse: parse,
	  findIconDefinition: findIconDefinition,
	  icon: icon,
	  text: text,
	  layer: layer
	};
	
	var autoReplace = function autoReplace() {
	  if (IS_DOM && config$1.autoReplaceSvg) api$1.dom.i2svg({ node: DOCUMENT });
	};
	
	function bootstrap() {
	  if (IS_BROWSER) {
	    if (!WINDOW.FontAwesome) {
	      WINDOW.FontAwesome = api$1;
	    }
	
	    domready(function () {
	      if (Object.keys(namespace.styles).length > 0) {
	        autoReplace();
	      }
	
	      if (config$1.observeMutations && typeof MutationObserver === 'function') {
	        observe({
	          treeCallback: onTree,
	          nodeCallback: onNode,
	          pseudoElementsCallback: searchPseudoElements
	        });
	      }
	    });
	  }
	
	  namespace.hooks = _extends({}, namespace.hooks, {
	
	    addPack: function addPack(prefix, icons) {
	      namespace.styles[prefix] = _extends({}, namespace.styles[prefix] || {}, icons);
	
	      build();
	      autoReplace();
	    },
	
	    addShims: function addShims(shims) {
	      var _namespace$shims;
	
	      (_namespace$shims = namespace.shims).push.apply(_namespace$shims, toConsumableArray(shims));
	
	      build();
	      autoReplace();
	    }
	  });
	}
	
	Object.defineProperty(api$1, 'config', {
	  get: function get() {
	    return config$1;
	  },
	
	  set: function set(newConfig) {
	    update(newConfig);
	  }
	});
	
	if (IS_DOM) bunker(bootstrap);
	
	var config = api$1.config;
	
	exports.config = config;
	exports['default'] = api$1;
	exports.icon = icon;
	exports.noAuto = noAuto;
	exports.layer = layer;
	exports.text = text;
	exports.library = library;
	exports.dom = dom;
	exports.parse = parse;
	exports.findIconDefinition = findIconDefinition;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {(function (global, factory) {
		 true ? module.exports = factory(__webpack_require__(29), __webpack_require__(2), __webpack_require__(1)) :
		typeof define === 'function' && define.amd ? define(['@fortawesome/fontawesome', 'prop-types', 'react'], factory) :
		(global['react-fontawesome'] = factory(global.FontAwesome,global.PropTypes,global.React));
	}(this, (function (fontawesome,PropTypes,React) { 'use strict';
	
	fontawesome = fontawesome && fontawesome.hasOwnProperty('default') ? fontawesome['default'] : fontawesome;
	PropTypes = PropTypes && PropTypes.hasOwnProperty('default') ? PropTypes['default'] : PropTypes;
	React = React && React.hasOwnProperty('default') ? React['default'] : React;
	
	var commonjsGlobal = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
	
	
	
	
	
	function createCommonjsModule(fn, module) {
		return module = { exports: {} }, fn(module, module.exports), module.exports;
	}
	
	var humps = createCommonjsModule(function (module) {
	// =========
	// = humps =
	// =========
	// Underscore-to-camelCase converter (and vice versa)
	// for strings and object keys
	
	// humps is copyright © 2012+ Dom Christie
	// Released under the MIT license.
	
	
	(function(global) {
	
	  var _processKeys = function(convert, obj, options) {
	    if(!_isObject(obj) || _isDate(obj) || _isRegExp(obj) || _isBoolean(obj) || _isFunction(obj)) {
	      return obj;
	    }
	
	    var output,
	        i = 0,
	        l = 0;
	
	    if(_isArray(obj)) {
	      output = [];
	      for(l=obj.length; i<l; i++) {
	        output.push(_processKeys(convert, obj[i], options));
	      }
	    }
	    else {
	      output = {};
	      for(var key in obj) {
	        if(Object.prototype.hasOwnProperty.call(obj, key)) {
	          output[convert(key, options)] = _processKeys(convert, obj[key], options);
	        }
	      }
	    }
	    return output;
	  };
	
	  // String conversion methods
	
	  var separateWords = function(string, options) {
	    options = options || {};
	    var separator = options.separator || '_';
	    var split = options.split || /(?=[A-Z])/;
	
	    return string.split(split).join(separator);
	  };
	
	  var camelize = function(string) {
	    if (_isNumerical(string)) {
	      return string;
	    }
	    string = string.replace(/[\-_\s]+(.)?/g, function(match, chr) {
	      return chr ? chr.toUpperCase() : '';
	    });
	    // Ensure 1st char is always lowercase
	    return string.substr(0, 1).toLowerCase() + string.substr(1);
	  };
	
	  var pascalize = function(string) {
	    var camelized = camelize(string);
	    // Ensure 1st char is always uppercase
	    return camelized.substr(0, 1).toUpperCase() + camelized.substr(1);
	  };
	
	  var decamelize = function(string, options) {
	    return separateWords(string, options).toLowerCase();
	  };
	
	  // Utilities
	  // Taken from Underscore.js
	
	  var toString = Object.prototype.toString;
	
	  var _isFunction = function(obj) {
	    return typeof(obj) === 'function';
	  };
	  var _isObject = function(obj) {
	    return obj === Object(obj);
	  };
	  var _isArray = function(obj) {
	    return toString.call(obj) == '[object Array]';
	  };
	  var _isDate = function(obj) {
	    return toString.call(obj) == '[object Date]';
	  };
	  var _isRegExp = function(obj) {
	    return toString.call(obj) == '[object RegExp]';
	  };
	  var _isBoolean = function(obj) {
	    return toString.call(obj) == '[object Boolean]';
	  };
	
	  // Performant way to determine if obj coerces to a number
	  var _isNumerical = function(obj) {
	    obj = obj - 0;
	    return obj === obj;
	  };
	
	  // Sets up function which handles processing keys
	  // allowing the convert function to be modified by a callback
	  var _processor = function(convert, options) {
	    var callback = options && 'process' in options ? options.process : options;
	
	    if(typeof(callback) !== 'function') {
	      return convert;
	    }
	
	    return function(string, options) {
	      return callback(string, convert, options);
	    }
	  };
	
	  var humps = {
	    camelize: camelize,
	    decamelize: decamelize,
	    pascalize: pascalize,
	    depascalize: decamelize,
	    camelizeKeys: function(object, options) {
	      return _processKeys(_processor(camelize, options), object);
	    },
	    decamelizeKeys: function(object, options) {
	      return _processKeys(_processor(decamelize, options), object, options);
	    },
	    pascalizeKeys: function(object, options) {
	      return _processKeys(_processor(pascalize, options), object);
	    },
	    depascalizeKeys: function () {
	      return this.decamelizeKeys.apply(this, arguments);
	    }
	  };
	
	  if (false) {
	    undefined(humps);
	  } else if ('object' !== 'undefined' && module.exports) {
	    module.exports = humps;
	  } else {
	    global.humps = humps;
	  }
	
	})(commonjsGlobal);
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	  return typeof obj;
	} : function (obj) {
	  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	};
	
	
	
	
	
	var asyncGenerator = function () {
	  function AwaitValue(value) {
	    this.value = value;
	  }
	
	  function AsyncGenerator(gen) {
	    var front, back;
	
	    function send(key, arg) {
	      return new Promise(function (resolve, reject) {
	        var request = {
	          key: key,
	          arg: arg,
	          resolve: resolve,
	          reject: reject,
	          next: null
	        };
	
	        if (back) {
	          back = back.next = request;
	        } else {
	          front = back = request;
	          resume(key, arg);
	        }
	      });
	    }
	
	    function resume(key, arg) {
	      try {
	        var result = gen[key](arg);
	        var value = result.value;
	
	        if (value instanceof AwaitValue) {
	          Promise.resolve(value.value).then(function (arg) {
	            resume("next", arg);
	          }, function (arg) {
	            resume("throw", arg);
	          });
	        } else {
	          settle(result.done ? "return" : "normal", result.value);
	        }
	      } catch (err) {
	        settle("throw", err);
	      }
	    }
	
	    function settle(type, value) {
	      switch (type) {
	        case "return":
	          front.resolve({
	            value: value,
	            done: true
	          });
	          break;
	
	        case "throw":
	          front.reject(value);
	          break;
	
	        default:
	          front.resolve({
	            value: value,
	            done: false
	          });
	          break;
	      }
	
	      front = front.next;
	
	      if (front) {
	        resume(front.key, front.arg);
	      } else {
	        back = null;
	      }
	    }
	
	    this._invoke = send;
	
	    if (typeof gen.return !== "function") {
	      this.return = undefined;
	    }
	  }
	
	  if (typeof Symbol === "function" && Symbol.asyncIterator) {
	    AsyncGenerator.prototype[Symbol.asyncIterator] = function () {
	      return this;
	    };
	  }
	
	  AsyncGenerator.prototype.next = function (arg) {
	    return this._invoke("next", arg);
	  };
	
	  AsyncGenerator.prototype.throw = function (arg) {
	    return this._invoke("throw", arg);
	  };
	
	  AsyncGenerator.prototype.return = function (arg) {
	    return this._invoke("return", arg);
	  };
	
	  return {
	    wrap: function (fn) {
	      return function () {
	        return new AsyncGenerator(fn.apply(this, arguments));
	      };
	    },
	    await: function (value) {
	      return new AwaitValue(value);
	    }
	  };
	}();
	
	
	
	
	
	
	
	
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	
	
	
	
	
	
	
	
	
	
	
	
	var objectWithoutProperties = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	
	var toConsumableArray = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];
	
	    return arr2;
	  } else {
	    return Array.from(arr);
	  }
	};
	
	function capitalize(val) {
	  return val.charAt(0).toUpperCase() + val.slice(1);
	}
	
	function styleToObject(style) {
	  return style.split(';').map(function (s) {
	    return s.trim();
	  }).filter(function (s) {
	    return s;
	  }).reduce(function (acc, pair) {
	    var i = pair.indexOf(':');
	    var prop = humps.camelize(pair.slice(0, i));
	    var value = pair.slice(i + 1).trim();
	
	    prop.startsWith('webkit') ? acc[capitalize(prop)] = value : acc[prop] = value;
	
	    return acc;
	  }, {});
	}
	
	function convert(createElement, element) {
	  var extraProps = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  var children = (element.children || []).map(convert.bind(null, createElement));
	
	  var mixins = Object.keys(element.attributes || {}).reduce(function (acc, key) {
	    var val = element.attributes[key];
	
	    switch (key) {
	      case 'class':
	        acc.attrs['className'] = val;
	        delete element.attributes['class'];
	        break;
	      case 'style':
	        acc.attrs['style'] = styleToObject(val);
	        break;
	      default:
	        if (key.indexOf('aria-') === 0 || key.indexOf('data-') === 0) {
	          acc.attrs[key.toLowerCase()] = val;
	        } else {
	          acc.attrs[humps.camelize(key)] = val;
	        }
	    }
	
	    return acc;
	  }, { attrs: {} });
	
	  var _extraProps$style = extraProps.style,
	      existingStyle = _extraProps$style === undefined ? {} : _extraProps$style,
	      remaining = objectWithoutProperties(extraProps, ['style']);
	
	
	  mixins.attrs['style'] = _extends({}, mixins.attrs['style'], existingStyle);
	
	  return createElement.apply(undefined, [element.tag, _extends({}, mixins.attrs, remaining)].concat(toConsumableArray(children)));
	}
	
	var PRODUCTION = false;
	
	try {
	  PRODUCTION = ("production") === 'production';
	} catch (e) {}
	
	var log = function () {
	  if (!PRODUCTION && console && typeof console.error === 'function') {
	    var _console;
	
	    (_console = console).error.apply(_console, arguments);
	  }
	};
	
	function objectWithKey(key, value) {
	  return Array.isArray(value) && value.length > 0 || !Array.isArray(value) && value ? defineProperty({}, key, value) : {};
	}
	
	function classList(props) {
	  var _classes;
	
	  var classes = (_classes = {
	    'fa-spin': props.spin,
	    'fa-pulse': props.pulse,
	    'fa-fw': props.fixedWidth,
	    'fa-border': props.border,
	    'fa-li': props.listItem,
	    'fa-flip-horizontal': props.flip === 'horizontal' || props.flip === 'both',
	    'fa-flip-vertical': props.flip === 'vertical' || props.flip === 'both'
	  }, defineProperty(_classes, 'fa-' + props.size, props.size !== null), defineProperty(_classes, 'fa-rotate-' + props.rotation, props.rotation !== null), defineProperty(_classes, 'fa-pull-' + props.pull, props.pull !== null), _classes);
	
	  return Object.keys(classes).map(function (key) {
	    return classes[key] ? key : null;
	  }).filter(function (key) {
	    return key;
	  });
	}
	
	function normalizeIconArgs(icon) {
	  if (icon === null) {
	    return null;
	  }
	
	  if ((typeof icon === 'undefined' ? 'undefined' : _typeof(icon)) === 'object' && icon.prefix && icon.iconName) {
	    return icon;
	  }
	
	  if (Array.isArray(icon) && icon.length === 2) {
	    return { prefix: icon[0], iconName: icon[1] };
	  }
	
	  if (typeof icon === 'string') {
	    return { prefix: 'fas', iconName: icon };
	  }
	}
	
	function FontAwesomeIcon$1(props) {
	  var iconArgs = props.icon,
	      maskArgs = props.mask,
	      symbol = props.symbol,
	      className = props.className;
	
	
	  var icon = normalizeIconArgs(iconArgs);
	  var classes = objectWithKey('classes', [].concat(toConsumableArray(classList(props)), toConsumableArray(className.split(' '))));
	  var transform = objectWithKey('transform', typeof props.transform === 'string' ? fontawesome.parse.transform(props.transform) : props.transform);
	  var mask = objectWithKey('mask', normalizeIconArgs(maskArgs));
	
	  var renderedIcon = fontawesome.icon(icon, _extends({}, classes, transform, mask, {
	    symbol: symbol
	  }));
	
	  if (!renderedIcon) {
	    log('Could not find icon', icon);
	    return null;
	  }
	
	  var abstract = renderedIcon.abstract;
	
	  var convertCurry = convert.bind(null, React.createElement);
	  var extraProps = {};
	
	  Object.keys(props).forEach(function (key) {
	    if (!FontAwesomeIcon$1.defaultProps.hasOwnProperty(key)) extraProps[key] = props[key];
	  });
	
	  return convertCurry(abstract[0], extraProps);
	}
	
	FontAwesomeIcon$1.displayName = 'FontAwesomeIcon';
	
	FontAwesomeIcon$1.propTypes = {
	  border: PropTypes.bool,
	
	  className: PropTypes.string,
	
	  mask: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
	
	  fixedWidth: PropTypes.bool,
	
	  flip: PropTypes.oneOf(['horizontal', 'vertical', 'both']),
	
	  icon: PropTypes.oneOfType([PropTypes.object, PropTypes.array, PropTypes.string]),
	
	  listItem: PropTypes.bool,
	
	  pull: PropTypes.oneOf(['right', 'left']),
	
	  pulse: PropTypes.bool,
	
	  name: PropTypes.string,
	
	  rotation: PropTypes.oneOf([90, 180, 270]),
	
	  size: PropTypes.oneOf(['lg', 'xs', 'sm', '1x', '2x', '3x', '4x', '5x', '6x', '7x', '8x', '9x', '10x']),
	
	  spin: PropTypes.bool,
	
	  symbol: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
	
	  transform: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
	};
	
	FontAwesomeIcon$1.defaultProps = {
	  border: false,
	  className: '',
	  mask: null,
	  fixedWidth: false,
	  flip: null,
	  icon: null,
	  listItem: false,
	  pull: null,
	  pulse: false,
	  name: '',
	  rotation: null,
	  size: null,
	  spin: false,
	  symbol: false,
	  transform: null
	};
	
	fontawesome.noAuto();
	
	return FontAwesomeIcon$1;
	
	})));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 28:
/***/ (function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ }),

/***/ 263:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
	(function() {
	  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
	
	  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
	    module.exports = function() {
	      return performance.now();
	    };
	  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
	    module.exports = function() {
	      return (getNanoSeconds() - nodeLoadTime) / 1e6;
	    };
	    hrtime = process.hrtime;
	    getNanoSeconds = function() {
	      var hr;
	      hr = hrtime();
	      return hr[0] * 1e9 + hr[1];
	    };
	    moduleLoadTime = getNanoSeconds();
	    upTime = process.uptime() * 1e9;
	    nodeLoadTime = moduleLoadTime - upTime;
	  } else if (Date.now) {
	    module.exports = function() {
	      return Date.now() - loadTime;
	    };
	    loadTime = Date.now();
	  } else {
	    module.exports = function() {
	      return new Date().getTime() - loadTime;
	    };
	    loadTime = new Date().getTime();
	  }
	
	}).call(this);
	
	//# sourceMappingURL=performance-now.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(72)))

/***/ }),

/***/ 72:
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),

/***/ 266:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(263)
	  , root = typeof window === 'undefined' ? global : window
	  , vendors = ['moz', 'webkit']
	  , suffix = 'AnimationFrame'
	  , raf = root['request' + suffix]
	  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]
	
	for(var i = 0; !raf && i < vendors.length; i++) {
	  raf = root[vendors[i] + 'Request' + suffix]
	  caf = root[vendors[i] + 'Cancel' + suffix]
	      || root[vendors[i] + 'CancelRequest' + suffix]
	}
	
	// Some versions of FF have rAF but not cAF
	if(!raf || !caf) {
	  var last = 0
	    , id = 0
	    , queue = []
	    , frameDuration = 1000 / 60
	
	  raf = function(callback) {
	    if(queue.length === 0) {
	      var _now = now()
	        , next = Math.max(0, frameDuration - (_now - last))
	      last = next + _now
	      setTimeout(function() {
	        var cp = queue.slice(0)
	        // Clear queue here to prevent
	        // callbacks from appending listeners
	        // to the current frame's queue
	        queue.length = 0
	        for(var i = 0; i < cp.length; i++) {
	          if(!cp[i].cancelled) {
	            try{
	              cp[i].callback(last)
	            } catch(e) {
	              setTimeout(function() { throw e }, 0)
	            }
	          }
	        }
	      }, Math.round(next))
	    }
	    queue.push({
	      handle: ++id,
	      callback: callback,
	      cancelled: false
	    })
	    return id
	  }
	
	  caf = function(handle) {
	    for(var i = 0; i < queue.length; i++) {
	      if(queue[i].handle === handle) {
	        queue[i].cancelled = true
	      }
	    }
	  }
	}
	
	module.exports = function(fn) {
	  // Wrap in a new function to prevent
	  // `cancel` potentially being assigned
	  // to the native rAF function
	  return raf.call(root, fn)
	}
	module.exports.cancel = function() {
	  caf.apply(root, arguments)
	}
	module.exports.polyfill = function(object) {
	  if (!object) {
	    object = root;
	  }
	  object.requestAnimationFrame = raf
	  object.cancelAnimationFrame = caf
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ }),

/***/ 287:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.animateScroll = undefined;
	exports.updateHistory = updateHistory;
	
	var _requestanimationframeTimer = __webpack_require__(292);
	
	var animateScroll = exports.animateScroll = function () {
	  var timeoutId = void 0;
	  var resolvePrevious = void 0;
	
	  return function animateScroll(id, animate) {
	    return new Promise(function (resolve, reject) {
	      var element = id ? document.getElementById(id) : document.body;
	
	      if (!element) {
	        return reject('Cannot find element: #' + id);
	      }
	
	      var offset = animate.offset,
	          duration = animate.duration,
	          easing = animate.easing;
	
	      var start = getScrollTop();
	      var to = getOffsetTop(element) + offset;
	      var change = to - start;
	
	      function animateFn() {
	        var elapsedTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
	
	        var increment = 20;
	        var elapsed = elapsedTime + increment;
	        var position = easing(null, elapsed, start, change, duration);
	        setScrollTop(position);
	        if (elapsed < duration) {
	          timeoutId = (0, _requestanimationframeTimer.setTimeout)(function () {
	            animateFn(elapsed);
	          }, increment);
	        } else {
	          timeoutId = undefined;
	          return resolve(id);
	        }
	      }
	
	      if (timeoutId) {
	        (0, _requestanimationframeTimer.clearTimeout)(timeoutId);
	        resolvePrevious();
	      }
	      resolvePrevious = resolve;
	      animateFn();
	    });
	  };
	}();
	
	function updateHistory(id) {
	  id = '#' + id;
	  if (history.pushState) {
	    history.pushState(null, null, id);
	  } else {
	    location.hash = id;
	  }
	}
	
	function getScrollTop() {
	  // like jQuery -> $('html, body').scrollTop
	  return document.documentElement.scrollTop || document.body.scrollTop;
	}
	
	function setScrollTop(position) {
	  document.documentElement.scrollTop = document.body.scrollTop = position;
	}
	
	function getOffsetTop(element) {
	  var _element$getBoundingC = element.getBoundingClientRect(),
	      top = _element$getBoundingC.top;
	
	  return top + getScrollTop();
	}

/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _helpers = __webpack_require__(287);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Scrollchor = function (_React$Component) {
	  _inherits(Scrollchor, _React$Component);
	
	  function Scrollchor(props) {
	    _classCallCheck(this, Scrollchor);
	
	    var _this = _possibleConstructorReturn(this, (Scrollchor.__proto__ || Object.getPrototypeOf(Scrollchor)).call(this, props));
	
	    _this._handleClick = function (event) {
	      _this.state.beforeAnimate(event);
	      event && event.preventDefault();
	      (0, _helpers.animateScroll)(_this.state.to, _this.state.animate).then(function (id) {
	        if (id) {
	          _this.state.disableHistory || (0, _helpers.updateHistory)(id);
	          _this.state.afterAnimate(event);
	        }
	      });
	    };
	
	    _this.state = Scrollchor._stateHelper(props);
	    _this.simulateClick = _this._handleClick;
	    return _this;
	  }
	
	  _createClass(Scrollchor, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(props) {
	      this.setState(Scrollchor._stateHelper(props));
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          to = _props.to,
	          animate = _props.animate,
	          beforeAnimate = _props.beforeAnimate,
	          afterAnimate = _props.afterAnimate,
	          disableHistory = _props.disableHistory,
	          props = _objectWithoutProperties(_props, ['to', 'animate', 'beforeAnimate', 'afterAnimate', 'disableHistory']); // eslint-disable-line no-unused-vars
	
	      return !this.props.children ? null : _react2.default.createElement('a', _extends({}, props, { href: '#' + this.state.to, onClick: this._handleClick }));
	    }
	  }], [{
	    key: '_stateHelper',
	    value: function _stateHelper(props) {
	      var _ref = props.animate || {},
	          _ref$offset = _ref.offset,
	          offset = _ref$offset === undefined ? 0 : _ref$offset,
	          _ref$duration = _ref.duration,
	          duration = _ref$duration === undefined ? 400 : _ref$duration,
	          _ref$easing = _ref.easing,
	          easing = _ref$easing === undefined ? easeOutQuad : _ref$easing;
	
	      return {
	        to: props.to && props.to.replace(/^#/, '') || '',
	        animate: { offset: offset, duration: duration, easing: easing },
	        beforeAnimate: props.beforeAnimate || function () {},
	        afterAnimate: props.afterAnimate || function () {},
	        disableHistory: props.disableHistory
	      };
	    }
	  }, {
	    key: 'getDerivedStateFromProps',
	    value: function getDerivedStateFromProps(props) {
	      return Scrollchor._stateHelper(props);
	    }
	  }]);
	
	  return Scrollchor;
	}(_react2.default.Component);
	
	// Default easing function
	// jQuery easing 'swing'
	
	
	Scrollchor.propTypes = {
	  to: _propTypes2.default.string.isRequired,
	  animate: _propTypes2.default.shape({
	    offset: _propTypes2.default.number,
	    duration: _propTypes2.default.number,
	    easing: _propTypes2.default.func
	  }),
	  beforeAnimate: _propTypes2.default.func,
	  afterAnimate: _propTypes2.default.func,
	  disableHistory: _propTypes2.default.bool,
	  children: _propTypes2.default.node
	};
	exports.default = Scrollchor;
	function easeOutQuad(x, t, b, c, d) {
	  return -c * (t /= d) * (t - 2) + b;
	}
	
	// Setup for React version 16.3.x and beyond
	var reSemver = /^v?((\d+)\.(\d+)\.(\d+))(?:-([\dA-Za-z\-]+(?:\.[\dA-Za-z\-]+)*))?(?:\+([\dA-Za-z\-]+(?:\.[\dA-Za-z\-]+)*))?$/; // eslint-disable-line no-useless-escape
	
	var _reSemver$exec = reSemver.exec(_react2.default.version),
	    _reSemver$exec2 = _slicedToArray(_reSemver$exec, 4),
	    major = _reSemver$exec2[2],
	    minor = _reSemver$exec2[3];
	
	major >= 16 && minor >= 3 && delete Scrollchor.prototype.componentWillReceiveProps;

/***/ }),

/***/ 292:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(293).default;

/***/ }),

/***/ 293:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _raf = __webpack_require__(266);
	
	var _raf2 = _interopRequireDefault(_raf);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var MODE_TIMEOUT = 0;
	var MODE_INTERVAL = 1;
	var fnStacks = new Map();
	var runArray = new Set();
	var rafStarted = false;
	var startId = 0;
	
	function getTimeStamp() {
	  return new Date().getTime();
	}
	
	function executeFn(value) {
	  var fn = value.fn,
	      args = value.args;
	
	  fn.apply(undefined, _toConsumableArray(args));
	}
	
	function runFunction() {
	  if (runArray.size === 0) return;
	  runArray.forEach(executeFn);
	  runArray.clear();
	}
	
	var checkTick = function checkTick(currentTimeTick) {
	  return function (value, id) {
	    var nextTick = value.nextTick,
	        ms = value.ms,
	        mode = value.mode;
	
	    if (currentTimeTick - nextTick >= 0) {
	      runArray.add(value);
	      if (mode === MODE_TIMEOUT) {
	        fnStacks.delete(id);
	      } else {
	        fnStacks.set(id, Object.assign({}, value, {
	          nextTick: nextTick + ms
	        }));
	      }
	    }
	  };
	};
	
	function loop() {
	  var currentTimeTick = getTimeStamp();
	  fnStacks.forEach(checkTick(currentTimeTick));
	  runFunction();
	  if (fnStacks.size === 0) {
	    rafStarted = false;
	    return;
	  }
	  (0, _raf2.default)(loop);
	}
	
	function addId(_ref) {
	  var fn = _ref.fn,
	      _ref$ms = _ref.ms,
	      ms = _ref$ms === undefined ? 0 : _ref$ms,
	      args = _ref.args,
	      mode = _ref.mode;
	
	  if (!fn) return null;
	  var currentId = startId;
	  fnStacks.set(currentId, {
	    fn: fn,
	    ms: ms,
	    nextTick: getTimeStamp() + ms,
	    args: args,
	    mode: mode
	  });
	  if (!rafStarted) {
	    rafStarted = true;
	    (0, _raf2.default)(loop);
	  }
	  startId += 1;
	  return currentId;
	}
	
	function removeId(id) {
	  if (fnStacks.has(id)) {
	    fnStacks.delete(id);
	  }
	  if (fnStacks.size === 0) {
	    rafStarted = false;
	  }
	}
	
	exports.default = {
	  setTimeout: function setTimeout(fn) {
	    for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      args[_key - 2] = arguments[_key];
	    }
	
	    var ms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    return addId({ fn: fn, ms: ms, args: args, mode: MODE_TIMEOUT });
	  },
	  clearTimeout: removeId,
	  setInterval: function setInterval(fn) {
	    for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	      args[_key2 - 2] = arguments[_key2];
	    }
	
	    var ms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    return addId({ fn: fn, ms: ms, args: args, mode: MODE_INTERVAL });
	  },
	  clearInterval: removeId
	};

/***/ }),

/***/ 78:
/***/ (function(module, exports) {

	/** @license React v0.19.1
	 * scheduler.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var f,g,h,k,l;
	if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
	y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
	typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
	function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
	function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
	function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
	function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
	function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
	exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
	exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
	exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(78);
	} else {
	  module.exports = require('./cjs/scheduler.development.js');
	}


/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var About = function (_React$PureComponent) {
	  _inherits(About, _React$PureComponent);
	
	  function About() {
	    _classCallCheck(this, About);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  About.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "about-container" },
	      _react2.default.createElement(
	        "div",
	        { className: "terminal" },
	        _react2.default.createElement(
	          "div",
	          { className: "terminal-header" },
	          _react2.default.createElement("div", { className: "header-button red" }),
	          _react2.default.createElement("div", { className: "header-button yellow" }),
	          _react2.default.createElement("div", { className: "header-button green" })
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: "terminal-window" },
	          _react2.default.createElement(Statements, { statements: this.props.statements })
	        )
	      )
	    );
	  };
	
	  return About;
	}(_react2.default.PureComponent);
	
	var Statements = function (_React$PureComponent2) {
	  _inherits(Statements, _React$PureComponent2);
	
	  function Statements() {
	    _classCallCheck(this, Statements);
	
	    return _possibleConstructorReturn(this, _React$PureComponent2.apply(this, arguments));
	  }
	
	  Statements.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      null,
	      this.props.statements.map(function (statement, index) {
	        return _react2.default.createElement(Statement, { statement: statement, key: index });
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "statement" },
	        _react2.default.createElement(
	          "div",
	          { className: "input-statement" },
	          _react2.default.createElement(
	            "span",
	            null,
	            "\xA0"
	          )
	        )
	      )
	    );
	  };
	
	  return Statements;
	}(_react2.default.PureComponent);
	
	var Statement = function (_React$PureComponent3) {
	  _inherits(Statement, _React$PureComponent3);
	
	  function Statement() {
	    _classCallCheck(this, Statement);
	
	    return _possibleConstructorReturn(this, _React$PureComponent3.apply(this, arguments));
	  }
	
	  Statement.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "statement" },
	      _react2.default.createElement(
	        "div",
	        { className: "input-statement" },
	        this.props.statement.input
	      ),
	      _react2.default.createElement("div", {
	        className: "return-statement",
	        dangerouslySetInnerHTML: { __html: this.props.statement.return }
	      })
	    );
	  };
	
	  return Statement;
	}(_react2.default.PureComponent);
	
	exports.default = About;
	module.exports = exports["default"];

/***/ }),

/***/ 136:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ContactLinks = function (_React$PureComponent) {
	  _inherits(ContactLinks, _React$PureComponent);
	
	  function ContactLinks() {
	    _classCallCheck(this, ContactLinks);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  ContactLinks.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "contact-links" },
	      _react2.default.createElement(
	        "span",
	        null,
	        _react2.default.createElement(
	          "a",
	          {
	            rel: "noopener",
	            target: "_blank",
	            href: "https://www.linkedin.com/in/dhaval-singh-502b79161/"
	          },
	          "LinkedIn"
	        )
	      ),
	      _react2.default.createElement(
	        "span",
	        null,
	        _react2.default.createElement(
	          "a",
	          { rel: "noopener", target: "_blank", href: "mailto:dhavalsingh19@gmail.com" },
	          "dhavalsingh19@gmail.com"
	        )
	      ),
	      _react2.default.createElement(
	        "span",
	        null,
	        _react2.default.createElement(
	          "a",
	          { rel: "noopener", target: "_blank", href: "https://github.com/dhavalsingh-eGov" },
	          "github"
	        )
	      )
	    );
	  };
	
	  return ContactLinks;
	}(_react2.default.PureComponent);
	
	exports.default = ContactLinks;
	module.exports = exports["default"];

/***/ }),

/***/ 137:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Footer = function (_React$PureComponent) {
	  _inherits(Footer, _React$PureComponent);
	
	  function Footer() {
	    _classCallCheck(this, Footer);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  Footer.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      { className: "footer" },
	      _react2.default.createElement(
	        "span",
	        null,
	        "Made by Dhaval Singh \xA9 ",
	        new Date().getFullYear()
	      )
	    );
	  };
	
	  return Footer;
	}(_react2.default.PureComponent);
	
	exports.default = Footer;
	module.exports = exports["default"];

/***/ }),

/***/ 138:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Typewriter = __webpack_require__(142);
	
	var _Typewriter2 = _interopRequireDefault(_Typewriter);
	
	var _reactScrollchor = __webpack_require__(119);
	
	var _reactScrollchor2 = _interopRequireDefault(_reactScrollchor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Hero = function (_React$PureComponent) {
	  _inherits(Hero, _React$PureComponent);
	
	  function Hero(props) {
	    _classCallCheck(this, Hero);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.call(this, props));
	  }
	
	  Hero.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'hero-container' },
	      _react2.default.createElement(_Typewriter2.default, { className: 'hero-title', text: 'Dhaval Singh' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'hero-description' },
	        'I am a software developer at Procol.',
	        _react2.default.createElement('br', null),
	        'Check out my ',
	        _react2.default.createElement(
	          _reactScrollchor2.default,
	          { to: '#projects' },
	          'projects'
	        ),
	        ' ',
	        'below.'
	      )
	    );
	  };
	
	  return Hero;
	}(_react2.default.PureComponent);
	
	exports.default = Hero;
	module.exports = exports['default'];

/***/ }),

/***/ 139:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactCarousel = __webpack_require__(123);
	
	var _reactCarousel2 = _interopRequireDefault(_reactCarousel);
	
	__webpack_require__(228);
	
	var _dota = __webpack_require__(306);
	
	var _dota2 = _interopRequireDefault(_dota);
	
	var _barca = __webpack_require__(303);
	
	var _barca2 = _interopRequireDefault(_barca);
	
	var _office = __webpack_require__(308);
	
	var _office2 = _interopRequireDefault(_office);
	
	var _reddit = __webpack_require__(311);
	
	var _reddit2 = _interopRequireDefault(_reddit);
	
	var _am = __webpack_require__(302);
	
	var _am2 = _interopRequireDefault(_am);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Gallery = function (_React$Component) {
	  _inherits(Gallery, _React$Component);
	
	  function Gallery() {
	    _classCallCheck(this, Gallery);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this));
	
	    _this.state = { value: 0 };
	    _this.onChange = _this.onChange.bind(_this);
	    return _this;
	  }
	
	  Gallery.prototype.onChange = function onChange(value) {
	    this.setState({ value: value });
	  };
	
	  Gallery.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'me-container' },
	      _react2.default.createElement(
	        'div',
	        { className: 'me-description' },
	        _react2.default.createElement(
	          'p',
	          null,
	          'A random collection of things i love!'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        {
	          style: {
	            display: 'flex',
	            justifyContent: 'center',
	            flexFlow: 'row',
	            alignContent: 'center',
	            textAlign: 'center'
	          }
	        },
	        ' ',
	        _react2.default.createElement(_reactCarousel2.default, {
	          centered: true,
	          slidesPerPage: 4,
	          value: this.state.value,
	          onChange: this.onChange,
	          slides: [_react2.default.createElement('img', { src: _dota2.default }), _react2.default.createElement('img', { src: _barca2.default }), _react2.default.createElement('img', { src: _office2.default }), _react2.default.createElement('img', { src: _reddit2.default }), _react2.default.createElement('img', { src: _am2.default })],
	          arrows: true,
	          infinite: true,
	          offset: 9,
	          itemWidth: 250
	        })
	      )
	    );
	  };
	
	  return Gallery;
	}(_react2.default.Component);
	
	exports.default = Gallery;
	module.exports = exports['default'];

/***/ }),

/***/ 140:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactScrollchor = __webpack_require__(119);
	
	var _reactScrollchor2 = _interopRequireDefault(_reactScrollchor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Navbar = function (_React$PureComponent) {
	  _inherits(Navbar, _React$PureComponent);
	
	  function Navbar() {
	    _classCallCheck(this, Navbar);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  Navbar.prototype.componentDidMount = function componentDidMount() {
	    this.refs.navbar.addEventListener('click', function (e) {
	      if (e.target.innerText === 'Projects') {
	        document.getElementById('projects').scrollIntoView({ behavior: 'smooth' });
	      } else if (e.target.innerText === 'Contact') {
	        document.getElementById('contact').scrollIntoView({ behavior: 'smooth' });
	      } else if (e.target.innerText === 'About') {
	        document.getElementById('about').scrollIntoView({ behavior: 'smooth' });
	      }
	    });
	  };
	
	  Navbar.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'navbar-container' },
	      _react2.default.createElement(
	        'nav',
	        { className: 'navbar', ref: 'navbar' },
	        _react2.default.createElement(
	          _reactScrollchor2.default,
	          { to: '#projects' },
	          'Projects'
	        ),
	        _react2.default.createElement(
	          _reactScrollchor2.default,
	          { to: '#contact' },
	          'Contact'
	        )
	      )
	    );
	  };
	
	  return Navbar;
	}(_react2.default.PureComponent);
	
	exports.default = Navbar;
	module.exports = exports['default'];

/***/ }),

/***/ 141:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactFontawesome = __webpack_require__(42);
	
	var _reactFontawesome2 = _interopRequireDefault(_reactFontawesome);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ProjectSkill = function (_React$PureComponent) {
	  _inherits(ProjectSkill, _React$PureComponent);
	
	  function ProjectSkill() {
	    _classCallCheck(this, ProjectSkill);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  ProjectSkill.prototype.render = function render() {
	    return _react2.default.createElement(
	      'span',
	      { className: 'project-skill' },
	      this.props.skill
	    );
	  };
	
	  return ProjectSkill;
	}(_react2.default.PureComponent);
	
	var ProjectSkills = function (_React$PureComponent2) {
	  _inherits(ProjectSkills, _React$PureComponent2);
	
	  function ProjectSkills() {
	    _classCallCheck(this, ProjectSkills);
	
	    return _possibleConstructorReturn(this, _React$PureComponent2.apply(this, arguments));
	  }
	
	  ProjectSkills.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'project-skills' },
	      this.props.skills.map(function (skill, index) {
	        return _react2.default.createElement(ProjectSkill, { skill: skill, key: index });
	      })
	    );
	  };
	
	  return ProjectSkills;
	}(_react2.default.PureComponent);
	
	var ProjectLinks = function (_React$PureComponent3) {
	  _inherits(ProjectLinks, _React$PureComponent3);
	
	  function ProjectLinks() {
	    _classCallCheck(this, ProjectLinks);
	
	    return _possibleConstructorReturn(this, _React$PureComponent3.apply(this, arguments));
	  }
	
	  ProjectLinks.prototype.render = function render() {
	    var _props$links = this.props.links,
	        github = _props$links.github,
	        preview = _props$links.preview,
	        shouldHideGit = _props$links.shouldHideGit,
	        shouldHidePrev = _props$links.shouldHidePrev;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'project-links' },
	      _react2.default.createElement(
	        'a',
	        {
	          href: preview,
	          rel: 'noopener',
	          target: '_blank',
	          className: shouldHidePrev ? 'hiddenLink' : 'project-link'
	        },
	        'Live Demo ',
	        _react2.default.createElement(_reactFontawesome2.default, { icon: 'external-link-alt' })
	      ),
	      _react2.default.createElement(
	        'a',
	        {
	          href: github,
	          rel: 'noopener',
	          target: '_blank',
	          className: shouldHideGit ? 'hiddenLink' : 'project-link secondary'
	        },
	        _react2.default.createElement(_reactFontawesome2.default, { icon: ['fab', 'github'] }),
	        ' View Source'
	      )
	    );
	  };
	
	  return ProjectLinks;
	}(_react2.default.PureComponent);
	
	var ProjectCard = function (_React$PureComponent4) {
	  _inherits(ProjectCard, _React$PureComponent4);
	
	  function ProjectCard() {
	    _classCallCheck(this, ProjectCard);
	
	    return _possibleConstructorReturn(this, _React$PureComponent4.apply(this, arguments));
	  }
	
	  ProjectCard.prototype.render = function render() {
	    var _props = this.props,
	        image = _props.image,
	        title = _props.title,
	        duration = _props.duration,
	        description = _props.description,
	        skills = _props.skills,
	        links = _props.links;
	
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'project-card' },
	      _react2.default.createElement('img', { className: 'project-image', src: image }),
	      _react2.default.createElement('div', { className: 'project-background' }),
	      _react2.default.createElement(
	        'div',
	        { className: 'project-content' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          title
	        ),
	        _react2.default.createElement(
	          'h6',
	          null,
	          duration
	        ),
	        _react2.default.createElement('p', { dangerouslySetInnerHTML: { __html: description } }),
	        _react2.default.createElement(ProjectSkills, { skills: skills }),
	        _react2.default.createElement(ProjectLinks, { links: links })
	      )
	    );
	  };
	
	  return ProjectCard;
	}(_react2.default.PureComponent);
	
	var Projects = function (_React$PureComponent5) {
	  _inherits(Projects, _React$PureComponent5);
	
	  function Projects() {
	    _classCallCheck(this, Projects);
	
	    return _possibleConstructorReturn(this, _React$PureComponent5.apply(this, arguments));
	  }
	
	  Projects.prototype.render = function render() {
	    var projects = this.props.projects;
	
	    return _react2.default.createElement(
	      'div',
	      { className: 'projects-container' },
	      projects.map(function (proj) {
	        return _react2.default.createElement(ProjectCard, {
	          title: proj.title,
	          duration: proj.duration,
	          description: proj.description,
	          skills: proj.skills,
	          links: proj.links,
	          image: proj.image,
	          key: proj.title
	        });
	      })
	    );
	  };
	
	  return Projects;
	}(_react2.default.PureComponent);
	
	exports.default = Projects;
	module.exports = exports['default'];

/***/ }),

/***/ 142:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Typewriter = function (_React$Component) {
	  _inherits(Typewriter, _React$Component);
	
	  function Typewriter(props) {
	    _classCallCheck(this, Typewriter);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.state = {
	      text: ''
	    };
	    return _this;
	  }
	
	  Typewriter.prototype.clicketyClack = function clicketyClack(text, minTypeSpeed, maxTypeSpeed, initDelay) {
	    var _this2 = this;
	
	    var str = '';
	    var typeSpeed = 0;
	    var self = this;
	
	    text.split('').forEach(function (c) {
	      typeSpeed += Math.random() * (maxTypeSpeed - minTypeSpeed) + minTypeSpeed;
	      setTimeout(function () {
	        str += c;
	        _this2.setState({ text: str });
	      }, initDelay + typeSpeed);
	    });
	  };
	
	  Typewriter.prototype.componentDidMount = function componentDidMount() {
	    this.clicketyClack(this.props.text, this.props.minTypeSpeed, this.props.maxTypeSpeed, this.props.initDelay);
	  };
	
	  Typewriter.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: this.props.className },
	      this.state.text,
	      _react2.default.createElement(
	        'span',
	        null,
	        '\xA0'
	      )
	    );
	  };
	
	  return Typewriter;
	}(_react2.default.Component);
	
	Typewriter.defaultProps = {
	  text: 'Give me something to type!',
	  minTypeSpeed: 50,
	  maxTypeSpeed: 90,
	  initDelay: 700
	};
	
	exports.default = Typewriter;
	module.exports = exports['default'];

/***/ }),

/***/ 143:
/***/ (function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = [{
	  input: 'Dhaval.currentLocation',
	  return: '"Bangalore, India"'
	}, {
	  input: 'Dhaval.resume',
	  return: '"<a rel="noopener" href="/Dhaval_singh.pdf" target="_blank">DhavalSingh.pdf</a>"'
	}, {
	  input: 'Dhaval.Website',
	  return: '"<a rel="noopener" href="https://dhavalsingh.github.io/" target="_blank">Personal Website</a>"'
	}, {
	  input: 'Dhaval.education',
	  return: '"M.Sc. Physics and B.E. Electronics And Instrumentation from Bits Pilani K.K Birla Goa campus"'
	}, {
	  input: 'Dhaval.skills',
	  return: '["Java", "JavaScript", "Python", ""ReactJS, "C++", "HTML", "TypeScript", "git"]'
	}, {
	  input: 'Dhaval.interests',
	  return: '["Football", "Esports", "Cooking", "Movies"]'
	}];
	module.exports = exports['default'];

/***/ }),

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _travlr = __webpack_require__(312);
	
	var _travlr2 = _interopRequireDefault(_travlr);
	
	var _digit = __webpack_require__(305);
	
	var _digit2 = _interopRequireDefault(_digit);
	
	var _blog = __webpack_require__(304);
	
	var _blog2 = _interopRequireDefault(_blog);
	
	var _neutron = __webpack_require__(307);
	
	var _neutron2 = _interopRequireDefault(_neutron);
	
	var _portfolio = __webpack_require__(309);
	
	var _portfolio2 = _interopRequireDefault(_portfolio);
	
	var _webiste = __webpack_require__(313);
	
	var _webiste2 = _interopRequireDefault(_webiste);
	
	var _procol = __webpack_require__(310);
	
	var _procol2 = _interopRequireDefault(_procol);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// image can be any size. just make sure it is close to a 1:1 ratio - a square.
	
	exports.default = [{
	  title: 'Software Developer at Procol',
	  duration: 'July 2020- Ongoing',
	  description: 'Working on implementing new features in the Agribid dashboard as a front-end developer',
	  skills: ['React', 'JavaScript', 'Redux', 'AntD', 'HTML5', 'CSS', 'NodeJS'],
	  image: _procol2.default,
	  links: {
	    github: '',
	    preview: '',
	    shouldHideGit: true,
	    shouldHidePrev: true
	  }
	}, {
	  title: 'Software Developer(Internship) at eGoverments Foundation',
	  duration: 'Aug 2019- June 2020',
	  description: 'Collaborated in a cross-functional Platform team by developing highly scalable REST APIs based on the Micro-services architecture using Java Spring-Boot, JDBC, PostgreSQL, Kafka. Worked on Implementing SMS-OTPNotification service and using Kafka to integrate it with other services, Modifying the PaymentGateway service to be more agile and useless resources on the back-end,Testing and fixing SQL Injection vulnerabilities in the Report Service, Automating E2E Testing for the E-pass and MCS service using cypress framework and upgrading a lot of internal services as well.',
	  skills: ['Microservices', 'Java Spring Boot Framework', 'React', 'Cypress', 'Restful Web Services', 'PostgreSQL'],
	  image: _travlr2.default,
	  links: {
	    github: '',
	    preview: '',
	    shouldHideGit: true,
	    shouldHidePrev: true
	  }
	}, {
	  title: 'Portfolio',
	  duration: '',
	  description: 'This page! Responsive website built with ReactJS. The site content is passed in as JSON data, auto-generating components for easy maintenance.',
	  skills: ['HTML5', 'CSS', 'Sass', 'JavaScript', 'ReactJS'],
	  image: _portfolio2.default,
	  links: {
	    github: 'https://github.com/dhavalsingh/dhavalsingh.github.io',
	    preview: 'https://dhavalsingh.github.io/',
	    shouldHideGit: false,
	    shouldHidePrev: false
	  }
	}, {
	  title: 'Personal Website',
	  duration: '',
	  description: 'I created my personal responsive webiste with space inavaders game integrated.',
	  skills: ['HTML5', 'CSS', 'JavaScript', 'Jquery'],
	  image: _webiste2.default,
	  links: {
	    github: 'https://github.com/dhavalsingh/personalsite',
	    preview: 'https://dhavalsingh.github.io/personalsite/',
	    shouldHideGit: false,
	    shouldHidePrev: false
	  }
	}, {
	  title: 'Use of computational Physics in determining Neutron stars as potential gravitational wave emitters',
	  duration: 'Aug 2018 - April 2019',
	  description: 'RNS Code was used to solve the Tolman-Oppenheimer-Volkoff (TOV) equations and further used to construct models of non-rotating, relativistic, compact stars usingtabulated equations of state which are supplied by the user.',
	  skills: ['C++', 'Python', 'Matlab'],
	  image: _neutron2.default,
	  links: {
	    github: '',
	    preview: '',
	    shouldHideGit: true,
	    shouldHidePrev: true
	  }
	}, {
	  title: 'Handshake Vigilante',
	  duration: ' ',
	  description: 'My Blog based on Movie and Tv shows',
	  skills: ['Wordpress'],
	  image: _blog2.default,
	  links: {
	    github: 'https://handshakevigilante.wordpress.com/',
	    preview: 'https://handshakevigilante.wordpress.com/',
	    shouldHideGit: true,
	    shouldHidePrev: false
	  }
	}];
	module.exports = exports['default'];

/***/ }),

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/am.f09eaea5.jpg";

/***/ }),

/***/ 303:
/***/ (function(module, exports) {

	module.exports = "data:image/jpeg;base64,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"

/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/blog.fb3b9e5a.png";

/***/ }),

/***/ 305:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 306:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/dota2.3df4e029.jpg";

/***/ }),

/***/ 307:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/neutron.1f8e745f.jpg";

/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/office.de7b161d.jpg";

/***/ }),

/***/ 309:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/portfolio.dad074c5.png";

/***/ }),

/***/ 310:
/***/ (function(module, exports) {

	module.exports = "data:image/png;base64,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"

/***/ }),

/***/ 311:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/reddit.a8bf3c4d.png";

/***/ }),

/***/ 312:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/travlr.ff8681fb.jpg";

/***/ }),

/***/ 313:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/webiste.126a9455.png";

/***/ }),

/***/ 148:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Navbar = __webpack_require__(140);
	
	var _Navbar2 = _interopRequireDefault(_Navbar);
	
	var _Hero = __webpack_require__(138);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _About = __webpack_require__(135);
	
	var _About2 = _interopRequireDefault(_About);
	
	var _Projects = __webpack_require__(141);
	
	var _Projects2 = _interopRequireDefault(_Projects);
	
	var _ContactLinks = __webpack_require__(136);
	
	var _ContactLinks2 = _interopRequireDefault(_ContactLinks);
	
	var _Footer = __webpack_require__(137);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _More = __webpack_require__(139);
	
	var _More2 = _interopRequireDefault(_More);
	
	var _projects = __webpack_require__(144);
	
	var _projects2 = _interopRequireDefault(_projects);
	
	var _aboutMe = __webpack_require__(143);
	
	var _aboutMe2 = _interopRequireDefault(_aboutMe);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Home = function (_React$PureComponent) {
	  _inherits(Home, _React$PureComponent);
	
	  function Home() {
	    _classCallCheck(this, Home);
	
	    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
	  }
	
	  Home.prototype.render = function render() {
	    return _react2.default.createElement(
	      'div',
	      { className: 'home-container' },
	      _react2.default.createElement(_Navbar2.default, null),
	      _react2.default.createElement(_Hero2.default, null),
	      _react2.default.createElement(_About2.default, { statements: _aboutMe2.default }),
	      _react2.default.createElement(
	        'h2',
	        { id: 'projects', className: 'section-title' },
	        'Projects'
	      ),
	      _react2.default.createElement(_Projects2.default, { projects: _projects2.default }),
	      _react2.default.createElement(
	        'h2',
	        { id: 'aboutme', className: 'section-title-me' },
	        'About me'
	      ),
	      _react2.default.createElement(_More2.default, null),
	      _react2.default.createElement(
	        'h2',
	        { id: 'contact', className: 'section-title' },
	        'Contact me!'
	      ),
	      _react2.default.createElement(_ContactLinks2.default, null),
	      _react2.default.createElement(_Footer2.default, null)
	    );
	  };
	
	  return Home;
	}(_react2.default.PureComponent);
	
	exports.default = Home;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-index-js-cf1bb52109c1fbd59914.js